<template>
  <div>
    <Button @click="goBack" type="primary">
      <Icon type="ios-arrow-back"></Icon>
      返回
    </Button>
    <h1 style="text-align: center;">学生信息详情</h1>
    <Tabs type="card" :animated="false" @on-click="onTabClick" v-model="tabName">
      <TabPane label="基本信息" name="one">
        <Form ref="userInfoForm" class="form" :model="formData" :rules="userRule">
          <Row :gutter="16">
            <i-col :xs="24" :sm="24" :md="12" style="border-right: 1px dotted #ddd;">
              <Row :gutter="16">
                <Tag style="margin:0 0 20px 10px" color="yellow">基本信息</Tag>
              </Row>
              <Row :gutter="16">
                <i-col :xs="24" :sm="24" :md="14">
                  <Row :gutter="8">
                    <i-col :xs="24" :sm="12" :md="20">
                  <span>
                    <input type="text" name="enName" style="width: 0px;height: 0px;padding: 0;"></input>
                    <input type="password" name="password" style="width: 0px;height: 0px;padding: 0;"></input>
                  </span>
                      <Form-item :label-width="auto" label="英文名字：">
                        <Input v-model="formData.enName" autocomplete="off"></Input>
                      </Form-item>
                    </i-col>
                  </Row>
                  <Row :gutter="8">
                    <i-col :xs="24" :sm="12" :md="20">
                      <Form-item :label-width="auto" label="密码：">
                        <Input type="password" v-model="formData.password" autocomplete="off"></Input>
                      </Form-item>
                    </i-col>
                  </Row>
                  <Row :gutter="8">
                    <i-col :xs="24" :sm="12" :md="20">
                      <Form-item :label-width="auto" label="中文名字：">
                        <Input name="cnName" v-model="formData.cnName" autocomplete="off"></Input>
                      </Form-item>
                    </i-col>
                  </Row>
                </i-col>
                <i-col :xs="24" :sm="24" :md="10" style="text-align: center; margin-bottom: 20px;">
                  <a @click="openStudentPage">
                    <img :src="totalImageUrl" style="width: 100px; height: 100px; border: 1px solid #f0f0f0; margin: 10px auto;">
                  </a>
                  <single-one-pic-upload @on-file-change="handleResult" :text="text"></single-one-pic-upload>
                </i-col>
              </Row>
              <Row :gutter="16">
                <i-col :xs="24" :sm="12" :md="10">
                  <Form-item :label-width="auto" label="年龄：" prop="age">
                    <Input name="age" v-model="formData.age" @on-change="calcBirthdayFromAge"></Input>
                  </Form-item>
                </i-col>
                <i-col :xs="24" :sm="12" :md="10">
                  <Form-item :label-width="auto" label="性别：">
                    <Select v-model="formData.sex" transfer>
                      <Option v-for="item in $constant.sex" :value="item.code" :key="item.code">{{ item.text }}</Option>
                    </Select>
                  </Form-item>
                </i-col>
              </Row>
              <Row :gutter="16">
                <i-col :xs="24" :sm="12" :md="10">
                  <Form-item :label-width="auto" label="年级：">
                    <Select v-model="formData.grade" transfer>
                      <Option v-for="item in $constant.grade" :value="item.code" :key="item.code">{{ item.text }}</Option>
                    </Select>
                  </Form-item>
                </i-col>
                <i-col :xs="24" :sm="12" :md="10">
                  <Form-item :label-width="auto" label="生日：">
                    <el-date-picker
                      v-model.number="formData.birthday"
                      type="date"
                      placeholder="选择日期"
                      format="yyyy-MM-dd"
                      value-format="timestamp"
                      @change="calcAgeFromBirthday"
                      style="width: 100%">
                    </el-date-picker>
                  </Form-item>
                </i-col>
              </Row>
              <Row :gutter="16">
                <i-col :xs="24">
                  <Form-item :label-width="auto" label="生源地：">
                    <v-distpicker
                      :province="formData.province"
                      :city="formData.city"
                      :area="formData.block"
                      @province="onSelectedProvince"
                      @city="onSelectedCity"
                      @area="onSelectedArea"
                      :placeholders="placeholders">
                    </v-distpicker>
                  </Form-item>
                </i-col>
              </Row>
              <Row :gutter="16">
                <i-col :xs="24" :sm="16" :md="16">
                  <Form-item :label-width="auto" label="英语学习经历：">
                    <Select v-model="formData.learnEnglishTime" transfer>
                      <Option value="1">不足三个月</Option>
                      <Option value="2">一年左右</Option>
                      <Option value="3">一年以上</Option>
                      <Option value="4">没有学习过英语</Option>
                    </Select>
                  </Form-item>
                </i-col>
              </Row>
              <Row :gutter="16">
                <i-col :xs="24" :sm="24" :md="24">
                  <Form-item :label-width="auto" label="是否接触过外教：">
                    <RadioGroup v-model="formData.haveContactForeignTeacher">
                      <Radio label="-1"><span>否</span></Radio>
                      <Radio label="1"><span>是</span></Radio>
                      <Radio label="0"><span>不确定</span></Radio>
                    </RadioGroup>
                  </Form-item>
                </i-col>
                <i-col :xs="24" :sm="24" :md="24">
                  <Form-item :label-width="auto" label="允许修改请假规则：">
                    <i-switch v-model="formData.enabledRule" size="large" @on-change="handleEnabledRuleChange">
                      <span slot="open">是</span>
                      <span slot="close">否</span>
                    </i-switch>
                  </Form-item>
                </i-col>
                <i-col :xs="24" :sm="24" :md="24">
                  <Form-item :label-width="auto" label="支持多级别排课：">
                    <i-switch :value="formData.stars === 2" size="large" @on-change="handleMultiLevelScheduleChange">
                      <span slot="open">是</span>
                      <span slot="close">否</span>
                    </i-switch>
                  </Form-item>
                </i-col>
                <i-col :xs="24" :sm="24" :md="24">
                  <Form-item :label-width="auto" label="支持自主约课：">
                    <i-switch :value="formData.tchIdCopy === 1" size="large" @on-change="handleSelfBookingChange">
                      <span slot="open">是</span>
                      <span slot="close">否</span>
                    </i-switch>
                  </Form-item>
                </i-col>
                <i-col :xs="24" :sm="24" :md="24">
                  <Form-item :label-width="auto" label="允许阶段测：">
                    <i-switch :value="summativeEnabled" size="large" @on-change="handleSummativeEnabledChange">
                      <span slot="open">是</span>
                      <span slot="close">否</span>
                    </i-switch>
                  </Form-item>
                </i-col>
                <i-col :xs="24" :sm="24" :md="24">
                  <Form-item :label-width="auto" label="哈佛外教课权限：">
                    <i-switch :value="harvardForeignEnabled" size="large" @on-change="handleHarvardForeignAuthChange">
                      <span slot="open">是</span>
                      <span slot="close">否</span>
                    </i-switch>
                  </Form-item>
                </i-col>
                <i-col :xs="24" :sm="24" :md="24">
                  <Form-item :label-width="auto" label="阶段测蓝图：">
                    <Select :value="summativeBlueprintId" placeholder="请选择阶段测蓝图" transfer @on-change="handleSummativeBlueprintChange">
                      <Option v-for="item in summativeBlueprints" :value="item.id" :key="item.id">{{ item.segment && item.versionNo ? item.segment + ' / ' + item.versionNo : item.id }}</Option>
                    </Select>
                  </Form-item>
                </i-col>
              </Row>
              <Row :gutter="16">
                <i-col :xs="24" :sm="24" :md="22">
                  <Form-item :label-width="auto" label="家庭经济情况：">
                    <RadioGroup v-model="formData.familyEconomicSituation">
                      <Radio label="1"><span>非常好</span></Radio>
                      <Radio label="2"><span>一般</span></Radio>
                      <Radio label="3"><span>不是很好</span></Radio>
                      <Radio label="0"><span>不确定</span></Radio>
                    </RadioGroup>
                  </Form-item>
                </i-col>
              </Row>
              <Row :gutter="16">
                <i-col :xs="24" :sm="24" :md="24">
                  <Form-item :label-width="auto" label="是否重视英语学习：">
                    <RadioGroup v-model="formData.attentionEnglish">
                      <Radio label="1"><span>是</span></Radio>
                      <Radio label="2"><span>否</span></Radio>
                      <Radio label="0"><span>不确定</span></Radio>
                    </RadioGroup>
                  </Form-item>
                </i-col>
              </Row>
              <Row :gutter="16">
                <i-col :xs="24" :sm="24" :md="24">
                  <Form-item :label-width="auto" label="接通状态：">
                    <RadioGroup v-model="formData.connectionStatus">
                      <Radio label="1"><span>未拨打</span></Radio>
                      <Radio label="2"><span>拨打未接</span></Radio>
                      <Radio label="3"><span>拨打接通</span></Radio>
                      <Radio label="4"><span>无效资源</span></Radio>
                    </RadioGroup>
                  </Form-item>
                </i-col>
              </Row>
              <Row>
                <Form-item>
                  <span>绘本VIP:{{ formData.vipDesc || '未开通' }}</span>
                  <span style="margin-left: 30px;" v-if="appVersionData.versionName">APP版本信息：{{ appVersionTypeText }}/<span :style="{color: appVersionData.versionName === '7.0.5' ? '#19be6b' : '#ed4014'}">{{ appVersionData.versionName === '7.0.5' ? '最新版' : '旧版本' }}</span>/{{ appVersionData.loginTime ? $moment(appVersionData.loginTime).format('YYYY-MM-DD HH:mm') : '-' }}</span>
                </Form-item>
              </Row>
            </i-col>
            <i-col :xs="24" :sm="24" :md="12">
              <Row :gutter="16">
                <Tag style="margin:0 0 20px 10px" color="yellow">联系方式</Tag>
              </Row>
              <Row :gutter="16">
                <Form-item :label-width="auto" label="学生ID：">
                  <label>{{ formData.uid }}</label>
                </Form-item>
              </Row>
              <Row :gutter="16">
                <Form-item :label-width="auto" label="手机号码：" prop="mobile">
                  <Input v-model="formData.mobile" style="width: 220px"/>
                  <i-switch :value="formData.mobileRemind === 1 || !(formData.remarkMobile || '').replace(/[,\s]/g, '')" :disabled="!(formData.remarkMobile || '').replace(/[,\s]/g, '')" size="large" style="margin-left: 8px;" @on-change="handleMobileRemindChange">
                    <span slot="open">提醒</span>
                    <span slot="close">关</span>
                  </i-switch>
                  <div style="font-size: 12px; color: #999;">（开关打开则上课短信/电话提醒发到该号码；没有备用号码时始终提醒该号码）</div>
                </Form-item>
              </Row>
              <Row :gutter="16">
                <Form-item :label-width="auto" label="备用手机号码：">
                  <Input v-model="formData.remarkMobile" style="width: 220px"/>
                  <i-switch :value="formData.remarkMobileRemind === 1" size="large" style="margin-left: 8px;" @on-change="handleRemarkMobileRemindChange">
                    <span slot="open">提醒</span>
                    <span slot="close">关</span>
                  </i-switch>
                  <div style="font-size: 12px; color: #999;">（仅用于上课提醒，多个号码用英文逗号隔开；开关打开则提醒发到该号码，两个开关都开则两个号码都提醒）</div>
                </Form-item>
              </Row>
              <Row :gutter="16">
                <Form-item :label-width="auto" label="是否允许电话提醒：">
                  <RadioGroup v-model="formData.allowCallReminder">
                    <Radio label="0"><span>是</span></Radio>
                    <Radio label="-1"><span>否</span></Radio>
                  </RadioGroup>
                </Form-item>
              </Row>
              <Row :gutter="16">
                <Form-item :label-width="auto" label="是否允许短信提醒：">
                  <RadioGroup v-model="formData.allowSmsReminder">
                    <Radio label="0"><span>是</span></Radio>
                    <Radio label="-1"><span>否</span></Radio>
                  </RadioGroup>
                </Form-item>
              </Row>
              <Row :gutter="16">
                <Form-item :label-width="auto" label="课前电话提醒：">
                  <i-switch :value="formData.beforeClassCall === 1" size="large" @on-change="handleBeforeClassCallChange">
                    <span slot="open">开</span>
                    <span slot="close">关</span>
                  </i-switch>
                  <div style="font-size: 12px; color: #999;">（打开且“允许电话提醒”为是时，课前提醒会打电话）</div>
                </Form-item>
              </Row>
              <Row :gutter="16">
                <Form-item :label-width="auto" label="课前提醒时间：">
                  <Input v-model="formData.remindHours" placeholder="如 2,24" style="width: 220px"/>
                  <div style="font-size: 12px; color: #999;">（默认课前1小时提醒；可再填小时数，多个用英文逗号隔开）</div>
                </Form-item>
              </Row>
              <Row :gutter="16">
                <Form-item :label-width="auto" label="号码对应人：">
                  <RadioGroup v-model="formData.phoneRole">
                    <Radio label="1"><span>父亲</span></Radio>
                    <Radio label="2"><span>母亲</span></Radio>
                    <Radio label="3"><span>其他</span></Radio>
                  </RadioGroup>
                </Form-item>
              </Row>
              <Button type="primary" @click="addContact" style="margin-bottom: 10px;">添加联系人</Button>
              <Form-item prop="userContacts">
                <div v-for="(item, index) in formData.userContacts" :key="index">
                  <Row :gutter="16">
                    <Form-item style="margin-top: 10px">
                      <i-col :xs="24" :sm="10">
                        <Input placeholder="姓名" v-model="formData.userContacts[index].name" style="margin-bottom: 5px;"></Input>
                      </i-col>
                      <i-col :xs="24" :sm="10">
                        <Input placeholder="手机号码" v-model="formData.userContacts[index].mobile" :number="true" style="margin-bottom: 5px;"></Input>
                      </i-col>
                      <i-col :xs="24" :sm="4">
                        <Button @click="deleteContact(index)" style="width: 100%;">删除</Button>
                      </i-col>
                    </Form-item>
                  </Row>
                </div>
              </Form-item>
              <Row :gutter="16">
                <Form-item :label-width="auto" label="微信账号：" prop="wechatAccount">
                  <Input v-model="formData.wechatAccount" style="width: 100%"></Input>
                </Form-item>
              </Row>
              <Row :gutter="16">
                <Form-item :label-width="auto" label="地址：">
                  <Input v-model="formData.address" style="width: 100%; height: 60px;" type="textarea" :autosize="true"></Input>
                </Form-item>
              </Row>
              <Row :gutter="16">
                <Form-item :label-width="auto" label="个人信息备注：">
                  <Input v-model="formData.infoRemark" style="width: 100%; height: 60px;" type="textarea" :autosize="true"></Input>
                </Form-item>
              </Row>
              <div class="fixed-class-require">
                <div class="fixed-class-require-title">固定上课需求</div>
                <Input type="textarea" v-model="fixedClassRequire" :maxlength="500" :autosize="{minRows: 3, maxRows: 6}" placeholder="一行一个要求，例如：不放儿歌"></Input>
                <div class="fixed-class-require-tags" v-if="fixedRequireLines.length">
                  <Tag v-for="(item, index) in fixedRequireLines" :key="'zh-' + index" color="blue">{{ item }}</Tag>
                </div>
                <div class="fixed-class-require-en">老师看到的英文</div>
                <div class="fixed-class-require-tags" v-if="fixedRequireEnLines.length">
                  <Tag v-for="(item, index) in fixedRequireEnLines" :key="'en-' + index" color="green">{{ item }}</Tag>
                </div>
                <div class="fixed-class-require-empty" v-else>暂无</div>
                <Button type="primary" :loading="fixedClassRequireSaving" @click="saveFixedClassRequire">保存</Button>
                <div class="fixed-class-require-tip">一行一个要求。含中文会按行翻译成英文给老师看；清空后保存会去掉老师端标记。最多 500 字。</div>
              </div>

            </i-col>
          </Row>
          <hr style="border: 1px dotted #ddd; margin-bottom: 20px;">
          <Row :gutter="16">
            <i-col :xs="24" :sm="24" :md="12" style="border-right: 1px dotted #ddd;">
              <Row :gutter="16">
                <Tag style="margin-left: 10px;" color="yellow">学生来源标签</Tag>
              </Row>
              <Row :gutter="16">
                <i-col :xs="24" :sm="10">
                  <Form-item :label-width="auto" label="注册渠道：" style="margin-top: 10px">
                    <Input name="regType" v-model="formData.regType" disabled/>
                  </Form-item>
                </i-col>
              </Row>
              <Row :gutter="16">
                <i-col :xs="24" :sm="20">
                  <Form-item :label-width="auto" label="付费渠道：">
                    <RadioGroup v-model="formData.payCanal" v-for="item in $constant.studentTags" :key="item.code">
                      <Radio :label="item.code"><span>{{ item.text }}</span></Radio>
                    </RadioGroup>
                  </Form-item>
                </i-col>
              </Row>
              <hr style="border: 1px dotted #ddd">
              <div style="margin-top: 20px"/>
              <Row :gutter="16">
                <Tag style="margin-left: 10px" color="yellow">课顾电话跟进</Tag>
              </Row>
              <div style="margin:20px">
                <Row :gutter="16">
                  <i-col :xs="24" :sm="20">
                    <span style="font-size: 12px;margin-left: 10px">意向等级：</span>
                    <RadioGroup v-model="formData.intentLevel">
                      <Radio label=""><span>不论</span></Radio>
                      <Radio label="1"><span>高意向</span></Radio>
                      <Radio label="2"><span>意向一般</span></Radio>
                      <Radio label="3"><span>待跟进</span></Radio>
                      <Radio label="4"><span>无效资源</span></Radio>
                    </RadioGroup>
                  </i-col>
                </Row>
                <Row :gutter="16" style="margin-top: 12px;">
                  <i-col :xs="24" :sm="20">
                    <Form-item :label-width="auto" label="未分班主任提醒：">
                      <i-switch :value="formData.noStudyAdviserRemind === 1" size="large" @on-change="handleNoStudyAdviserRemindChange">
                        <span slot="open">开</span>
                        <span slot="close">关</span>
                      </i-switch>
                    </Form-item>
                  </i-col>
                </Row>
              </div>
            </i-col>
            <i-col :xs="24" :sm="24" :md="12" style="border-bottom: 1px dotted #ddd;">
              <Row :gutter="16">
                <Tag style="margin-left: 10px;margin-bottom: 10px;" color="yellow">学生属性标签</Tag>
              </Row>
              <Row :gutter="16">
             <span style="margin-left: 20px;font-size: 14px; display: block;" v-for="(val, key) in userModal" :key="key">
               {{ key }}:
               <span v-if="val!=null">
                <Tag style="margin-left: 10px" color="#80848f" v-for="item in val" :key="item">{{ item }}</Tag>
               </span>
               <span v-else>无</span>
              </span>
              </Row>
            </i-col>
          </Row>
        </Form>
        <div class="telephone" style="text-align: center; margin: 20px 0;">
          <Button
            type="primary"
            @click="dialTel"
            style="background-color: #007bff; color: white; font-size: 14px; padding: 5px 5px; border-radius: 5px;"
          >
          </Button>
        </div>
        <Row :gutter="16">
          <Tag color="yellow" style="margin-bottom: 15px; margin-left: 10px;">通话记录</Tag>
        </Row>
        <Table border :columns="callRecordTitle" :data="callRecordData" :reload="reload"></Table>
        <div class="footer" style="text-align: center;margin-top: 20px;">
          <Button type="primary" size="large" :loading="insertLoading" @click="addStudent" style="width: 40%; margin: 0 10px;">保存</Button>
          <Button type="primary" size="large" class="cancel" style="width: 40%; margin: 0 10px;">取消</Button>
        </div>
      </TabPane>
      <!--上课要求-->
<!--      <TabPane label="上课要求" name="classRequirement">-->
<!--        <Form ref="classRequirementForm" class="form" :model="formData" :rules="userRule">-->
<!--          <Row :gutter="16">-->
<!--            <i-col :xs="24" :sm="24" :md="20">-->
<!--              <Form-item :label-width="auto" label="上课要求：" prop="classRequirement">-->
<!--                <div>-->
<!--                  &lt;!&ndash; 课堂需求分类标签 &ndash;&gt;-->
<!--                  <div style="margin-bottom: 15px;">-->
<!--                    <span style="color: #999; font-size: 12px;">(外管审核后显示给老师)</span>-->
<!--                  </div>-->

<!--                  &lt;!&ndash; 一般需求 &ndash;&gt;-->
<!--                  <div style="margin-bottom: 15px;">-->
<!--                    <h5 style="display: inline-block; margin: 0 10px 8px 0;">一般需求：</h5>-->
<!--                    <CheckboxGroup v-model="formData.classRequirementTags">-->
<!--                      <Checkbox label="活跃一些" style="margin-right: 10px;"><span>活跃一些</span></Checkbox>-->
<!--                      <Checkbox label="多微笑，不要太严肃" style="margin-right: 10px;"><span>多微笑，不要太严肃</span></Checkbox>-->
<!--                      <Checkbox label="纠音" style="margin-right: 10px;"><span>纠音</span></Checkbox>-->
<!--                      <Checkbox label="纠正错误表达" style="margin-right: 10px;"><span>纠正错误表达</span></Checkbox>-->
<!--                      <Checkbox label="引导多开口" style="margin-right: 10px;"><span>引导多开口</span></Checkbox>-->
<!--                      <Checkbox label="多些互动" style="margin-right: 10px;"><span>多些互动</span></Checkbox>-->
<!--                      <Checkbox label="引导整句输出" style="margin-right: 10px;"><span>引导整句输出</span></Checkbox>-->
<!--                      <Checkbox label="多鼓励孩子" style="margin-right: 10px;"><span>多鼓励孩子</span></Checkbox>-->
<!--                      <Checkbox label="多给些奖励" style="margin-right: 10px;"><span>多给些奖励</span></Checkbox>-->
<!--                    </CheckboxGroup>-->
<!--                  </div>-->

<!--                  &lt;!&ndash; 低级别上课需求 &ndash;&gt;-->
<!--                  <div style="margin-bottom: 15px;">-->
<!--                    <h5 style="display: inline-block; margin: 0 10px 8px 0;">低级别上课需求：</h5>-->
<!--                    <CheckboxGroup v-model="formData.classRequirementTags">-->
<!--                      <Checkbox label="语速慢一点" style="margin-right: 10px;"><span>语速慢一点</span></Checkbox>-->
<!--                      <Checkbox label="多些TPR" style="margin-right: 10px;"><span>多些TPR</span></Checkbox>-->
<!--                      <Checkbox label="多些道具" style="margin-right: 10px;"><span>多些道具</span></Checkbox>-->
<!--                      <Checkbox label="课前互动简单一些（最多3个问题）" style="margin-right: 10px;"><span>课前互动简单一些（最多3个问题）</span></Checkbox>-->
<!--                      <Checkbox label="学生零基础，不要拓展" style="margin-right: 10px;"><span>学生零基础，不要拓展</span></Checkbox>-->
<!--                      <Checkbox label="减少拓展" style="margin-right: 10px;"><span>减少拓展</span></Checkbox>-->
<!--                    </CheckboxGroup>-->
<!--                  </div>-->

<!--                  &lt;!&ndash; 高级别上课需求 &ndash;&gt;-->
<!--                  <div style="margin-bottom: 15px;">-->
<!--                    <h5 style="display: inline-block; margin: 0 10px 8px 0;">高级别上课需求：</h5>-->
<!--                    <CheckboxGroup v-model="formData.classRequirementTags">-->
<!--                      <Checkbox label="内容拓展" style="margin-right: 10px;"><span>内容拓展</span></Checkbox>-->
<!--                    </CheckboxGroup>-->
<!--                  </div>-->

<!--                  &lt;!&ndash; 自定义输入框 &ndash;&gt;-->
<!--                  <div style="margin-top: 15px;">-->
<!--                    <Input name="classRequirement" v-model="formData.classRequirement" style="width: 100%; height: 60px;" type="textarea" :autosize="true" placeholder="可额外输入其他上课要求"></Input>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </Form-item>-->
<!--            </i-col>-->
<!--          </Row>-->
<!--          <div class="footer" style="text-align: center;margin-top: 20px;">-->
<!--            <Button type="primary" size="large" :loading="insertLoading" @click="addStudent" style="width: 40%; margin: 0 10px;">保存</Button>-->
<!--            <Button type="primary" size="large" class="cancel" style="width: 40%; margin: 0 10px;">取消</Button>-->
<!--          </div>-->
<!--        </Form>-->
<!--      </TabPane>-->
      <!--follow up-->
      <TabPane label="Follow Up" name="two">
        <Form ref="followForm" class="form" :model="followFormData" :rules="followRule">
          <Row :gutter="24">
            <Tag style="margin-left: 30px;" color="yellow">follow up</Tag>
          </Row>
          <Row :gutter="24">
            <i-col span="4" style="padding-left: 0;">
              <Form-item label="学生：" :label-width="120">
                <label>{{ followFormData.id }} -- {{ followFormData.nickname }}</label>
              </Form-item>
            </i-col>
            <i-col span="3">
              <Form-item label="课程顾问：" :label-width="80">
                <label>{{ followFormData.adviserName }}</label>
              </Form-item>
            </i-col>
            <i-col span="3">
              <Form-item label="学导：" :label-width="80">
                <label>{{ followFormData.studyAdviserName }}</label>
              </Form-item>
            </i-col>
            <i-col span="9">
              <Form-item label="绑定老师：" :label-width="80">
                <el-tag style="margin-right: 2px;" v-for="tchName in followFormData.tchNames">{{ tchName }}</el-tag>
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="20">
            <Form-item label="内容：" prop="content" :label-width="120">
              <Input v-model="followFormData.content" type="textarea" style="width: 500px;" :rows="4"
                     placeholder="请输入..."></Input>
            </Form-item>
          </Row>
          <Row :gutter="20">
            <i-col span="10">
              <Form-item label="状态：" prop="traceStatus" :label-width="120">
                <Select v-model="followFormData.traceStatus" @on-change="changeFollow" transfer>
                  <Option value="1">高跟进</Option>
                  <Option value="2">跟进中</Option>
                  <Option value="3">跟进低</Option>
                  <Option value="4">无意向</Option>
                  <Option value="5">多次联系不到</Option>
                  <Option value="100">注册备注</Option>
                </Select>
              </Form-item>
            </i-col>
            <i-col span="10">
              <Form-item :label-width="50" prop="traceItem">
                <Select v-model="followFormData.traceItem" transfer>
                  <Option v-for="item in followList"
                          :value="item.id" :key="item.id">{{ item.text }}
                  </Option>
                </Select>
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="20" v-if="followFormData.traceStatus == 100 || followFormData.traceStatus == '100'">
            <Form-item label="上传截图" :label-width="120">
              <multiple-image-upload :num="100" v-model="followFormData.files"/>
            </Form-item>
          </Row>
          <Row :gutter="20">
            <Form-item label="下次联系时间：" prop="nextDate" :label-width="120">
              <DatePicker v-model="nextDate" type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                          @on-change="changeDate"></DatePicker>
            </Form-item>
          </Row>
          <Row :gutter="20">
            <Form-item label="对老师要求：" :label-width="120">
              <ElSwitch v-model="askForTch"></ElSwitch>
            </Form-item>
            <template v-if="askForTch">
              <Form-item label="对学生描述：" :label-width="120">
                <el-checkbox-group v-model="followFormData.stuDescCheckGroup" size="mini" :max="3">
                  <el-checkbox v-for="item in $constant.stuDesc" :label="item.code" :key="item.code" border>
                    {{ item.text }}
                  </el-checkbox>
                </el-checkbox-group>
              </Form-item>
              <Form-item label="对老师要求：" :label-width="120">
                <el-checkbox-group v-model="followFormData.askForTchCheckGroup" size="mini" :max="5">
                  <el-checkbox v-for="item in $constant.askForTch" :label="item.code" :key="item.code" border>
                    {{ item.text }}
                  </el-checkbox>
                </el-checkbox-group>
              </Form-item>
            </template>
          </Row>
          <div style="margin: 0 0 40px 35px;">
            <Button type="primary" style="margin-right: 20px;" @click="addFollow">保存</Button>
            <Button type="primary">取消</Button>
          </div>
        </Form>
        <Row :gutter="24">
          <Tag color="yellow" style="margin-bottom: 15px; margin-left: 30px;">follow up记录</Tag>
        </Row>
        <Table border :columns="followtitle" :data="followData" :reload="reload"
               style="margin-left: 30px;margin-right:30px;"></Table>
      </TabPane>
      <!--推荐老师-->
      <TabPane label="推荐老师" name="tree">
        <Button type="primary" @click="openRecommendEdit">添加老师</Button>
        <RecommendList style="margin-top: 10px" :uid="formData.uid" listUrl="/tchRecommend/list"
                       :tableColumns="recommendTitle" :reset="reset" :data="recommendData"></RecommendList>
      </TabPane>
      <TabPane label="阶段报告" name="four">
        <!-- <Button type="primary"  @click="insertReport">添加阶段报告</Button>-->
        <Table border :columns="stageReportTitle" :data="stageReportData" :reload="reload"
               style="margin-top: 10px"></Table>
      </TabPane>
      <TabPane label="学生跟踪记录" name="five">
        <Form ref="form" :model="formValidate" :rules="ruleValidate" :label-width="90" class="form">
          <Row>
            <Col :sm="11" :md="5">
              <Form-item label="学生ID">
                <Input readonly v-model.number="formValidate.uid" :maxlength="10" :disabled="disable"></Input>
              </Form-item>
            </Col>
            <Col :sm="11" :md="5">
              <Form-item label="学生姓名" prop="nickname">
                <Input readonly placeholder="只读" v-model="formValidate.nickname" :disabled="disable"></Input>
              </Form-item>
            </Col>
            <Col :sm="11" :md="5">
              <Form-item label="课程顾问" prop="adviserName">
                <Input readonly placeholder="只读"
                       v-model="formValidate.adviserName" :disabled="disable"></Input>
              </Form-item>
            </Col>
            <Col :sm="11" :md="5">
              <Form-item label="学导" prop="studyAdviserName">
                <Input readonly placeholder="只读"
                       v-model="formValidate.studyAdviserName" :disabled="disable"></Input>
              </Form-item>
            </Col>
          </Row>
          <Row>
            <Col :sm="22" :md="18">
              <Form-item label="内容" prop="content">
                <Input v-model="formValidate.content" type="textarea" :autosize="{minRows: 3, maxRows: 10}"></Input>
                <div style="margin-top: 8px">
                  <Button type="primary" ghost size="small" :loading="aiLoading" :disabled="aiLoading" @click="handleAiMarkdown">AI 处理</Button>
                  <span style="margin-left: 8px; color: #999; font-size: 12px">将通话/听记原文清洗为结构化 Markdown</span>
                </div>
              </Form-item>
            </Col>
          </Row>
          <Row>
            <Col :sm="11" :md="5">
              <Form-item label="下次联系日期">
                <Date-picker type="date" :clearable="false" @on-change="nextTimeDateChange"
                             v-model="formValidate.nextTimeDate"></Date-picker>
              </Form-item>
            </Col>
            <Col :sm="11" :md="5">
              <Form-item label="下次联系人">
                <Select v-model.number="formValidate.nextHandlerId" transfer>
                  <Option v-for="item in nextHandler"
                          :value="item.id" :key="item.id">{{ item.nickname }}
                  </Option>
                </Select>
              </Form-item>
            </Col>
            <Col :sm="11" :md="5">
              <Form-item label="记录属性" prop="traceType">
                <Select v-model="formValidate.traceType" transfer>
                  <Option value="1">新注册学生</Option>
                  <Option value="11">分配记录</Option>
                  <Option value="21">试听课记录</Option>
                  <Option value="31">成交记录</Option>
                  <Option value="41">交接记录</Option>
                  <Option value="51">绑定记录</Option>
                  <Option value="61">上课跟进记录</Option>
                  <Option value="71">转介绍跟进记录</Option>
                  <Option value="99">其他</Option>
                </Select>
              </Form-item>
            </Col>
            <Col :sm="11" :md="5">
              <Form-item label="上传截图" prop="url">
                <multiple-image-upload :num="100" :defaultFileList="defaultPicList" v-model="formValidate.files"
                                       on-file-change="onFileChange"/>
              </Form-item>
            </Col>
          </Row>
          <Form-item>
            <Button type="primary" @click="handleSubmit">提交</Button>
          </Form-item>
        </Form>
        <div>
          <!--<scroll height="800">-->
          <table class="track-list" style="width: 100%">
            <thead>
            <tr>
              <th width="4%">序号</th>
              <th width="10%">记录属性</th>
              <th width="16%">添加时间</th>
              <th width="40%">内容</th>
              <th width="10%">下次联系日期</th>
              <th width="10%">下次联系人</th>
              <th width="10%">操作人</th>
            </tr>
            </thead>
            <tbody>
            <tr :key="index" v-for="(item, index) in tableData">
              <td>{{ index + 1 }}</td>
              <td :rowspan="item.rowSpan" :hidden="item.hidden">{{ item.showName }}</td>
              <td>
                <span>{{ item.createTime }}</span>
              </td>
              <td>
                <TrackContentPreview :content="item.content" @view="openTrackContent(item)">
                  <a v-if="item.showName == '注册学员备注' && item.nickname && item.nickname.trim() !== ''"
                     href="javascript:void(0)"
                     style="margin-left:8px"
                     @click="viewPic(item)">查看图片</a>
                </TrackContentPreview>
              </td>
              <td v-if="item.nextHandlerTime == '0000-00-00 00:00:00'">{{ item.nextHandlerTime }}</td>
              <td v-else>0</td>
              <td>{{ item.nextHandlerName }}</td>
              <td>{{ item.createName }}</td>
            </tr>
            </tbody>
          </table>
          <!--</scroll>-->
          <Page :total="traceParam.totalCount" show-elevator className="page" :current="traceParam.pageIndex"
                :pageSize="traceParam.pageSize" @on-change="changePageIndex" show-total></Page>
        </div>
      </TabPane>
      <TabPane label="订单合同" name="six">
        <RecommendList :reload="reload_fundPackage" :uid="formData.uid" listUrl="/fundPackage/list"
                       :tableColumns="fundPackageTitle" :reset="fundPackageRest"
                       :data="fundPackageData"></RecommendList>
      </TabPane>
      <TabPane label="课时统计" name="seven">
        <Table border :columns="courseTypeTitle" :data="courseTypeData" style="margin-top: 10px"
               v-if="formData.tchChannel === 1">
        </Table>
        <hr style="border: 2px solid #f0f0f0; margin-bottom: 20px; margin-top: 20px;"/>
        <div class="search" @keyup.enter="searchWithPage">
          <Form :label-width="60" :show-message="false">
            <Row :gutter="12">
              <Col span="7">
                <Form-item label="上课时间">
                  <Row>
                    <Col span="11">
                      <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                                   @on-change="startTimeDateChange"
                                   v-model="lessonParams.startTimeDate"></Date-picker>
                    </Col>
                    <Col span="2" style="text-align: center">-</Col>
                    <Col span="11">
                      <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                                   @on-change="endTimeDateChange"
                                   v-model="lessonParams.endTimeDate"></Date-picker>
                    </Col>
                  </Row>
                </Form-item>
              </Col>
              <Col span="4">
                <Form-item label="学导">
                  <Input placeholder="支持模糊搜索" name="studyAdviserNickname"
                         v-model="lessonParams.studyAdviserNickname"></Input>
                </Form-item>
              </Col>
              <Col span="4">
                <Form-item label="课程顾问昵称" :label-width="85">
                  <Input placeholder="支持模糊搜索" name="adviserNickname"
                         v-model="lessonParams.adviserNickname"></Input>
                </Form-item>
              </Col>
              <Col span="4">
                <Form-item label="老师ID">
                  <Input name="tchId"
                         v-model="lessonParams.tchId"></Input>
                </Form-item>
              </Col>
              <Col span="4">
                <Form-item label="老师姓名">
                  <Input placeholder="支持模糊搜索" name="tchName"
                         v-model="lessonParams.tchName"></Input>
                </Form-item>
              </Col>

            </Row>
            <Row>
              <Col span="7">
                <Form-item label="排课时间">
                  <Row>
                    <Col span="11">
                      <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                                   @on-change="startCreateTimeChange"
                                   v-model="lessonParams.startCreateDate"></Date-picker>
                    </Col>
                    <Col span="2" style="text-align: center">-</Col>
                    <Col span="11">
                      <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                                   @on-change="endCreateTimeChange"
                                   v-model="lessonParams.endCreateDate"></Date-picker>
                    </Col>
                  </Row>
                </Form-item>
              </Col>
              <Col span="4">
                <Form-item label="课程类别" :label-width="80">
                  <Select v-model.number="lessonParams.courseType" placeholder="全部"
                          @on-change="searchWithPage" clearable>
                    <Option v-for="item in $constant.courseType"
                            :value="item.code" :key="item.code">{{ item.text }}
                    </Option>
                  </Select>
                </Form-item>
              </Col>
              <Col span="4">
                <Form-item label="状态">
                  <Select v-model.number="lessonParams.lsnSelStatus" placeholder="全部"
                          @on-change="searchWithPage" clearable>
                    <Option v-for="item in $constant.lsnSelStatus"
                            :value="item.code" :key="item.code">{{ item.text }}
                    </Option>
                  </Select>
                </Form-item>
              </Col>
              <Col span="4">
                <Form-item label="老师类型" :label-width="80">
                  <Select v-model.number="lessonParams.tchCategory" placeholder="全部"
                          @on-change="searchWithPage" clearable>
                    <Option v-for="item in $constant.teacherCategory"
                            :value="item.code" :key="item.code">{{ item.text }}
                    </Option>
                  </Select>
                </Form-item>
              </Col>
              <Col span="4">
                <Form-item label="课程类型" :label-width="80">
                  <Select v-model.number="lessonParams.lsnType" placeholder="全部"
                          @on-change="searchWithPage" clearable>
                    <Option v-for="item in $constant.bookLessonOpenedLsnType"
                            :value="item.code" :key="item.code">{{ item.text }}
                    </Option>
                  </Select>
                </Form-item>
              </Col>
            </Row>
            <Row>
              <Col span="4">
                <Form-item label="教材版本">
                  <Select v-model.number="lessonParams.materialVersionId" @on-change="searchWithPage"
                          placeholder="请选择" clearable>
                    <Option v-for="item in $constant.materialVersions" :key="item.code" :value="item.code">
                      {{ item.text }}
                    </Option>
                  </Select>
                </Form-item>
              </Col>
              <Col span="4">
                <Form-item label="是否分配学导" :label-width="100">
                  <Select v-model.number="lessonParams.isStudyAdviser" placeholder="全部"
                          @on-change="searchWithPage" clearable>
                    <Option value="1">已分配</Option>
                    <Option value="0">未分配</Option>
                  </Select>
                </Form-item>
              </Col>
              <Col span="4">
                <Form-item label="创建人">
                  <Input placeholder="支持模糊搜索" name="creatorName" v-model="lessonParams.creatorName"></Input>
                </Form-item>
              </Col>
              <Col span="6">
                <Form-item :label-width="50">
                  <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                          @click="searchWithPage">搜索
                  </Button>
                  <Button type="error" @click="openUserClassHourModal" icon="plus-round">加减课时</Button>
                  <Button type="error" @click="cancelAllClass">取消全部排课</Button>
                </Form-item>
              </Col>
            </Row>
          </Form>
        </div>
        <RecommendList ref="bookLessonList" :onLoading="onLessonLoading" :params="lessonParams" :uid="formData.uid"
                       listUrl="/bookLesson/opened/listByUid" :tableColumns="bookLessonTitle"
                       :reloadWithPage="reloadWithPage" :reset="bookLessonReset"></RecommendList>
      </TabPane>
      <TabPane label="交接工单" v-if="detailTabsReady && showWo" name="eight">
        <Form ref="woFormData" class="form" :model="woFormData.saleWo" :rules="woRule">
          <Row :gutter="24">
            <Tag style="margin-left: 30px;" color="yellow">交接工单</Tag>
          </Row>
          <Row :gutter="24">
            <i-col span="6" style="padding-left: 0;">
              <Form-item label="学生：" :label-width="120">
                <label>{{ woFormData.saleWo.studentId }} -- {{ woFormData.saleWo.studentName }}</label>
              </Form-item>
            </i-col>
            <i-col span="6">
              <Form-item label="年龄：" :label-width="80">
                <label v-if="woFormData.saleWo.age > 0">{{ woFormData.saleWo.age }}</label>
                <label v-if="woFormData.saleWo.age === 0"></label>
              </Form-item>
            </i-col>
            <i-col span="9">
              <Form-item label="绑定老师：" :label-width="80">
                <label>{{ woFormData.saleWo.teacherName }}</label>
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="24">
            <i-col span="6" style="padding-left: 0;">
              <Form-item label="订单类型：" :label-width="120">
                <label>{{ woFormData.saleWo.orderChannel.text }}</label>
              </Form-item>
            </i-col>
            <i-col span="6">
              <Form-item label="课程顾问：" :label-width="80">
                <label>{{ woFormData.saleWo.adviserName }}</label>
              </Form-item>
            </i-col>
            <i-col span="6">
              <Form-item label="付款金额：" prop="payAmount" :label-width="80">
                <Input :readonly="woReadonly" name="payAmount" v-model.number="woFormData.saleWo.payAmount"></Input>
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="24">
            <i-col span="6" style="padding-left: 0;">
              <Form-item label="工单版本：" label-width="120">
                <CheckboxGroup v-model="woVersion" @on-change="clickWoVersion" v-if="!woDisable">
                  <Checkbox label="1">新版</Checkbox>
                </CheckboxGroup>
                <label v-if="woDisable && woVersion === '1'">新版</label>
                <label v-if="woDisable && woVersion !== '1'">旧版</label>
              </Form-item>
            </i-col>
          </Row>

          <Row :gutter="24" v-if="woVersion === '1'">
            <i-col :span="22">
              <Form-item label="不可用时间：" prop="disableTime" label-width="120">
                <Row :gutter="8" v-if="!woDisable">
                  <i-col :span="2">
                    <Form-item prop="disableWeek">
                      <Select placeholder="星期" v-model="disableTimeParams.disableWeek" transfer
                              v-bind:disabled="woDisable">
                        <Option v-for="item in $constant.weekSelect" :value="item.code" :key="item.code">{{ item.text }}
                        </Option>
                      </Select>
                    </Form-item>
                  </i-col>
                  <i-col :span="4">
                    <Form-item prop="disableStartTime">
                      <Time-picker type="date" format="HH:mm" placeholder="开始时间" :steps="[1, 5]"
                                   @on-change="onChangeDisableStartTime"
                                   :clearable="false" :value="disableTimeParams.disableStartTimeStr"
                                   v-bind:disabled="woDisable"></Time-picker>
                    </Form-item>
                  </i-col>
                  <i-col :span="4">
                    <Form-item prop="disableEndTime">
                      <Time-picker type="date" format="HH:mm" placeholder="结束时间" :steps="[1, 5]"
                                   @on-change="onChangeDisableEndTime"
                                   :clearable="false" :value="disableTimeParams.disableEndTimeStr"
                                   v-bind:disabled="woDisable"></Time-picker>
                    </Form-item>
                  </i-col>
                  <i-col :span="2">
                    <Button type="info" @click="addDisableTime" v-bind:disabled="woDisable">添加</Button>
                  </i-col>
                </Row>
              </Form-item>
            </i-col>
          </Row>

          <Row :gutter="24" v-if="woVersion === '1'">
            <i-col :span="24">
              <Form-item label="已选择：" prop="disableTimeList" label-width="120">
                <Row>
                  <div v-for="(item, index) in disableTimeList" :key="index">
                    <Col span="22">
                      <label><b>&nbsp;&nbsp;&nbsp;&nbsp;{{ item.disableWeekStr }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {{ item.disableStartTimeStr }}&nbsp;&nbsp;&nbsp;&nbsp;--&nbsp;&nbsp;&nbsp;&nbsp;
                        {{ item.disableEndTimeStr }}&nbsp;&nbsp;&nbsp;&nbsp;
                      </b></label>
                      <Button type="error" size="small" v-if="!woDisable" v-bind:disabled="woDisable"
                              @click="removeDisableTime(index)">删除
                      </Button>
                    </Col>
                  </div>
                </Row>
              </Form-item>
            </i-col>
          </Row>

          <Row :gutter="20">
            <Form-item label="备注：" prop="remark" :label-width="120">
              <Input :readonly="woReadonly" v-model="woFormData.saleWo.remark" type="textarea" style="width: 500px;"
                     :rows="4" placeholder="请输入..."></Input>
            </Form-item>
          </Row>
          <!-- <Row :gutter="20" v-if="woFormData.saleWo.status=='UNAUDITED'">
            <Form-item label="拒绝理由：" prop="reason" :label-width="120"  style="width: 500px;" >
              <Select v-model="woFormData.saleWo.reason" transfer>
                    <Option v-for="item in $constant.woReason"
                              :value="item.text" :key="item.text">{{ item.text }}</Option>
                    </Select>
            </Form-item>
          </Row> -->
          <Row :gutter="20">
            <i-col span="10">
              <Form-item label="状态：" :label-width="120">
                <label>{{ woFormData.saleWo.woStatus.text }}</label>
              </Form-item>
            </i-col>
            <i-col span="10">
              <Form-item :label-width="50">
                <Button type="primary" v-if="!woReadonly" :loading="woSubmitLoading"
                        :disable="woSubmitLoading"
                        @click="saveWoData()">保存
                </Button>
                <Button type="primary" v-if="!woReadonly" :loading="woSubmitLoading"
                        :disable="woSubmitLoading"
                        @click="submitWoData()">提交工单
                </Button>
                <Button type="primary" v-if="woFormData.saleWo.status==='UNAUDITED' || woFormData.saleWo.status === 'APPROVED'" :loading="woSubmitLoading"
                        :disable="woSubmitLoading"
                        @click="rollbackWoData()">撤销工单
                </Button>
                <!-- <Button  type="primary" v-if="woFormData.saleWo.status=='UNAUDITED'"  :loading="woSubmitLoading"
                :disable="woSubmitLoading"
                 @click="submitWoData('APPROVE')">审核</Button>
                <Button  type="primary" v-if="woFormData.saleWo.status=='UNAUDITED'"  :loading="woSubmitLoading"
                :disable="woSubmitLoading"
                 @click="submitWoData('REJECTED')">拒绝</Button> -->
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="20" v-if="woVersion !== '1'">
            <Form-item label="首次开课时间：" prop="classOpeningTime" :label-width="120">
              <DatePicker :readonly="woReadonly" v-model="woFormData.saleWo.classOpeningTime" type="datetime"
                          format="yyyy-MM-dd HH:mm" placeholder="请选择日期" transfer></DatePicker>
            </Form-item>
          </Row>
          <Row :gutter="24">
            <Tag color="yellow" style="margin-bottom: 15px; margin-left: 30px;">工单记录</Tag>
          </Row>
          <Table border :columns="woFollowTitle" :data="woFormData.follows" :reload="reload"
                 style="margin-left: 30px;margin-right:30px;"></Table>
        </Form>
      </TabPane>
      <TabPane label="用户权益" name="nine" v-if="detailTabsReady && formData.tchChannel === 2">
        <Table border :columns="courseHourTitle" :data="classHourListData" style="margin-top: 10px">
        </Table>
      </TabPane>
    </Tabs>
    <RecommendTeacher :value="recommendEdit" :uid="formData.uid" @on-close="closeRecommendEdit"></RecommendTeacher>
    <StageReportModal v-model="StageReportModal" :uid="formData.uid" :successCallback="reportList"></StageReportModal>
    <EvaluationSheetModal :reprotId="reprotId" v-model="showEvaluationSheetModal" :successCallback="reportList"
                          @on-close="onEvaluationSheetModalClose"></EvaluationSheetModal>
    <BookUserFeedbackModal :openedId="openedId" v-model="showBookUserFeedbackModal"
                           @on-close="onBookUserFeedBackClose"></BookUserFeedbackModal>
    <BookTchFeedbackModal :openedId="openedId" v-model="showBookTchFeedbackModal"
                          @on-close="onBookTchFeedBackClose"></BookTchFeedbackModal>
    <BookTchScoreFeedbackModal :openedId="openedId" v-model="showBookTchScoreFeedbackModal"
                               @on-close="onBookTchScoreFeedBackClose"></BookTchScoreFeedbackModal>
    <ClassMemberTimeModal :openedId="openedId" v-model="showClassMemberTimeModal"
                          @on-close="onClassMemberClose"></ClassMemberTimeModal>
    <ChangeLessonModal :lessonOpened="lessonOpened" v-model="showChangeLessonModal"
                       :successCallback="searchWithPage"></ChangeLessonModal>
    <UserOneLeaveModal :openId="openId" :title="lessonTitle" :beginTime="lsnBeginTime" v-model="showUserOneLeaveModal"
                       @on-close="closeModal" :successCallback="searchWithPage"></UserOneLeaveModal>
    <TchLessonLeaveModal :openedId="openedId" v-model="showTchLessonLeaveModal" :title="lessonTitle"
                         :beginTime="lsnBeginTime" :successCallback="searchWithPage"></TchLessonLeaveModal>
    <LessonCancelModal :openedId="openedId" :lsnType="lsnType" v-model="showLessonCancelModal"
                       :tchChannel="formData.tchChannel" :successCallback="searchWithPage"></LessonCancelModal>
    <BalanceModal :openedId="openedId" :successCallback="searchWithPage" v-model="showBalanceModal"></BalanceModal>
    <RejectBalanceModal :openedId="openedId" :successCallback="searchWithPage"
                        v-model="showRejectBalanceModal"></RejectBalanceModal>
    <MonitorLessonRecordListModal :openedId="openedId"
                                  v-model="showMonitorLessonRecordListModal"></MonitorLessonRecordListModal>
    <UserClassHourModal :uid="formData.uid" v-model="showUserClassHourModal"></UserClassHourModal>
    <AddMonitorLessonRecordModal :openedId="openedId"
                                 v-model="showMonitorLessonRecordModal"></AddMonitorLessonRecordModal>
    <StudentWriteReviewDemoModal :openedId="openedId" :reviewState="reviewState" :value="studentWriteReviewDemoModal"
                                 :formData="studentWriteReviewDemoModalFormData"
                                 @on-close="closeReviewModal"></StudentWriteReviewDemoModal>
    <StudentWriteReviewDemoV2Modal :openedId="openedId" :reviewState="reviewState"
                                   :value="studentWriteReviewDemoV2Modal"
                                   :formData="studentWriteReviewDemoV2ModalFormData"
                                   @on-close="closeReviewModal"></StudentWriteReviewDemoV2Modal>
    <StudentWriteReviewRegularModal :openedId="openedId" :reviewState="reviewState"
                                    :value="studentWriteReviewRegularModal"
                                    :formData="studentWriteReviewRegularModalFormData"
                                    @on-close="closeReviewModal"></StudentWriteReviewRegularModal>
    <StudentWriteReviewRegularV2Modal :openedId="openedId" :reviewState="reviewState"
                                    :value="studentWriteReviewRegularV2Modal"
                                    :formData="studentWriteReviewRegularV2ModalFormData"
                                    @on-close="closeReviewModal"></StudentWriteReviewRegularV2Modal>
    <StudentWriteReviewFinishLevelModal :openedId="openedId" :reviewState="reviewState"
                                        :value="studentWriteReviewFinishLevelModal"
                                        :formData="studentWriteReviewFinishLevelModalFormData"
                                        @on-close="closeReviewModal"></StudentWriteReviewFinishLevelModal>
    <StudentWriteReviewFinishLevelV2Modal :openedId="openedId" :reviewState="reviewState"
                                        :value="studentWriteReviewFinishLevelV2Modal"
                                        :formData="studentWriteReviewFinishLevelV2ModalFormData"
                                        @on-close="closeReviewModal"></StudentWriteReviewFinishLevelV2Modal>
    <SearchChangeTchModal :optType="optType"
                          :user="tempLessonUser"
                          :changeTeacherOnly="changeTeacherOnly"
                          v-model="showSearchChangeTchModal"
                          :successCallback="searchWithPage"></SearchChangeTchModal>
    <Modal v-model="showVersionModel" title="修改版本号">
      <Select v-model="needversion">
        <Option value="1" key="1">版本一</Option>
        <Option value="2" key="2">版本二</Option>
        <Option value="3" key="3">版本三</Option>
        <Option value="4" key="4">版本四</Option>
      </Select>
      <div slot="footer">
        <Button type="text" size="large" @click="showVersionModel=false">取消</Button>
        <Button type="primary" size="large" @click="saveVersion">保存</Button>
      </div>
    </Modal>
    <Modal v-model="showContractStatusModel" title="修改合同状态">
      <Select v-model="needContractStatus">
        <Option value="0" key="0">使用中</Option>
        <Option value="1" key="1">未开启</Option>
        <Option value="2" key="2">已过期</Option>
      </Select>
      <div slot="footer">
        <Button type="text" size="large" @click="showContractStatusModel=false">取消</Button>
        <Button type="primary" size="large" @click="saveContractStatus">保存</Button>
      </div>
    </Modal>
    <ShowImageCarousel :imgList="showImgList" :value="showImgModal" @on-close="closeImgModal"></ShowImageCarousel>
    <UserTrackContentModal ref="trackContentModal"></UserTrackContentModal>
  </div>
</template>

<script>
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
import SingleOnePicUpload from '../common/SingleOnePicUpload.vue'
import RecommendTeacher from '../crm/RecommendTeacherModal.vue'
import RecommendList from '../common/RecommendList.vue'
import VDistpicker from 'v-distpicker'
import StageReportModal from '../crm/StageReportModal.vue'
import EvaluationSheetModal from '../crm/EvaluationSheetModal.vue'
import BookUserFeedbackModal from '../lesson/BookUserFeedbackModal.vue'
import BookTchFeedbackModal from '../lesson/BookTchFeedbackModal.vue'
import BookTchScoreFeedbackModal from '../lesson/BookTchScoreFeedbackModal.vue'
import ClassMemberTimeModal from '../lesson/ClassMemberTimeModal.vue'
import ChangeLessonModal from '../lesson/ChangeLessonModal.vue'
import UserOneLeaveModal from '../lesson/UserOneLeaveModal.vue'
import TchLessonLeaveModal from '../teacher/TchLessonLeaveModal.vue'
import LessonCancelModal from '../lesson/LessonCancelModal.vue'
import BalanceModal from '../lesson/BalanceModal.vue'
import RejectBalanceModal from '../lesson/RejectBalanceModal.vue'
import MonitorLessonRecordListModal from '../lesson/modal/MonitorLessonRecordListModal.vue'
import UserClassHourModal from './UserClassHourModal.vue'
import AddMonitorLessonRecordModal from '../lesson/modal/AddMonitorLessonRecordModal.vue'
import StudentWriteReviewDemoModal from './StudentWriteReviewDemoModal.vue'
import StudentWriteReviewDemoV2Modal from './StudentWriteReviewDemoV2Modal.vue'
import StudentWriteReviewRegularModal from './StudentWriteReviewRegularModal.vue'
import StudentWriteReviewRegularV2Modal from './StudentWriteReviewRegularV2Modal.vue'
import StudentWriteReviewFinishLevelModal from './StudentWriteReviewFinishLevelModal.vue'
import StudentWriteReviewFinishLevelV2Modal from './StudentWriteReviewFinishLevelV2Modal.vue'
import dates from '@/tools/date/dates.js'
import dateFormat from '@/tools/date/format.js'
import ShowImageCarousel from '../order/ShowImageCarousel'
import UserTrackContentModal from './UserTrackContentModal.vue'
import TrackContentPreview from './TrackContentPreview.vue'
import SearchChangeTchModal from '../lesson/modal/SearchChangeTchModal.vue'

export default {
  name: 'UserPayDetail',
  components: {
    TrackContentPreview,
    SearchChangeTchModal,
    ShowImageCarousel,
    SingleOnePicUpload,
    RecommendTeacher,
    RecommendList,
    VDistpicker,
    StageReportModal,
    EvaluationSheetModal,
    BookUserFeedbackModal,
    BookTchFeedbackModal,
    BookTchScoreFeedbackModal,
    ClassMemberTimeModal,
    ChangeLessonModal,
    UserOneLeaveModal,
    TchLessonLeaveModal,
    LessonCancelModal,
    BalanceModal,
    RejectBalanceModal,
    MonitorLessonRecordListModal,
    UserClassHourModal,
    AddMonitorLessonRecordModal,
    StudentWriteReviewDemoModal,
    StudentWriteReviewDemoV2Modal,
    StudentWriteReviewRegularModal,
    StudentWriteReviewRegularV2Modal,
    StudentWriteReviewFinishLevelModal,
    StudentWriteReviewFinishLevelV2Modal,
    UserTrackContentModal
  },
  data: function () {
    let $constant = this.$constant
    let $moment = this.$moment
    let $numeral = this.$numeral
    let self = this
    return {
      studentWriteReviewRegularModalFormData: {
        rate1: 2,
        rate2: 2,
        rate3: 2,
        rate4: 2,
        word1: [
          {remark: ''}, {remark: ''}, {remark: ''}
        ],
        word2: [
          {remark: ''}, {remark: ''}, {remark: ''}
        ],
        word3: [
          {remark: ''}, {remark: ''}, {remark: ''}
        ],
        word4: [
          {remark: ''}, {remark: ''}, {remark: ''}
        ],
        fileList: [],
        parent: '',
        levelMsg: '',
      },
      studentWriteReviewRegularV2ModalFormData: {
        rate1: 2,
        rate2: 2,
        rate3: 2,
        rate4: 2,
        rate5: 2,
        rate6: 2,
        word1: [
          {remark: ''}, {remark: ''}, {remark: ''}
        ],
        word2: [
          {remark: ''}, {remark: ''}, {remark: ''}
        ],
        parent: '',
      },
      studentWriteReviewDemoModalFormData: {
        remark: '',
        word1: '',
        word2: ''
      },
      studentWriteReviewFinishLevelModalFormData: {
        remark: '',
        suggestions: '',
        fileList: []
      },
      studentWriteReviewFinishLevelV2ModalFormData: {
        rate1: 2,
        rate2: 2,
        rate3: 2,
        rate4: 2,
        rate5: 2,
        rate6: 2,
        word1: '',
        word2: '',
        word3: ''
      },
      studentWriteReviewFinishLevelModal: false,
      studentWriteReviewRegularModal: false,
      studentWriteReviewDemoModal: false,
      studentWriteReviewFinishLevelV2Modal: false,
      studentWriteReviewRegularV2Modal: false,
      studentWriteReviewDemoV2Modal: false,
      showVersionModel: false,
      showContractStatusModel: false,
      fundPackageId: '',
      reload_fundPackage: 0,
      timer: '',
      time: 60,
      disabled: false,
      askForTch: false,
      nextDate: '',
      reprotId: null,
      cityInfo: '',
      insertLoading: false,
      fixedClassRequire: '',
      fixedClassRequireEn: '',
      fixedClassRequireSaving: false,
      StageReportModal: false,
      showEvaluationSheetModal: false,
      defaultPicList: [],
      searchLoading: false,
      rankScoreSeq: 0,
      followList: [],
      imageUrl: 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg',
      reload: 0,
      text: '编辑头像',
      totalImageUrl: '',
      currentTab: 'one',
      recommendData: null,
      fundPackageData: null,
      courseTypeData: [],
      classHourListData: [],
      paramsErrors: [],
      recommendEdit: false,
      reset: false,
      fundPackageRest: false,
      tabName: 'one',
      summativeEnabled: false,
      harvardForeignEnabled: false,
      harvardForeignLoaded: false,
      summativeBlueprintId: null,
      summativeBlueprints: [],
      summativeLoaded: false,
      placeholders: {
        province: '------- 省 --------',
        city: '--- 市 ---',
        area: '--- 区 ---',
      },
      formData: {
        enabledRule: false,
        stars: 1,
        tchIdCopy: 0,
        channelParam: '',
        oldMobile: '',
        smsCode: '',
        uid: null,
        reprotId: null,
        itemUrl: '',
        enName: '',
        cnName: '',
        canal: '',
        payCanal: '',
        mobile: '',
        remarkMobile: '',
        phoneRole: '',
        wechatAccount: '',
        infoRemark: '',
        address: '',
        learnEnglishTime: '',
        haveContactForeignTeacher: '',
        familyEconomicSituation: '',
        attentionEnglish: '',
        province: '',
        city: '',
        block: '',
        sex: '',
        password: '',
        imageUrl: '',
        intentLevel: '',
        noStudyAdviserRemind: 0,
        age: '',
        connectionStatus: '',
        userContacts: [],
        grade: '',
        birthday: null,
        exten: null,
        allowCallReminder: '',
        allowSmsReminder: '',
        mobileRemind: 1,
        remarkMobileRemind: 1,
        beforeClassCall: 0,
        remindHours: '',
        classRequirement: '',
        classRequirementTags: [],
        vipDesc: '',
        tchChannel: 1
      },
      followFormData: {
        id: '',
        nickname: '',
        adviserName: '',
        studyAdviserName: '',
        tchNames: [],
        traceStatus: '',
        traceItem: '',
        content: '',
        nextDate: '',
        files: '',
        stuDescCheckGroup: [],
        askForTchCheckGroup: [],
      },
      showWo: false,
      woChecked: false,
      userInfoChecked: false,
      showwoSubmit: true,
      showImgModal: false,
      woSubmitLoading: false,
      showImgList: [],
      woReadonly: false,
      woFormData: {
        saleWo: {
          id: '',
          studentId: '',
          payAmount: null,
          adviserName: '',
          studyAdviserName: '',
          teacherName: '',
          woStatus: '',
          remark: '',
          classOpeningTime: '',
          disableTimeList: null,
          woVersion: null,
          age: null
        },
        follows: []
      },
      nextHandler: [],
      uidReadonly: false,
      disable: false,
      aiLoading: false,
      formValidate: {
        id: '',
        uid: null,
        nickname: '',
        adviserName: '',
        studyAdviserName: '',
        content: '',
        contentRaw: '',
        nextHandlerId: null,
        status: '0',
        traceType: '',
        nextHandlerTime: '',
        nextTimeDate: '',
        files: ''
      },
      traceParam: {
        totalCount: 0,
        pageSize: 10,
        pageIndex: 1,
        uid: ''
      },
      tableData: [],
      ruleValidate: {
        content: [
          {required: true, message: '内容不能为空', trigger: 'blur'},
          {type: 'string', max: 10000, message: '内容不能超过10000个字', trigger: 'blur'}
        ],
        traceType: [
          {required: true, message: '属性不能为空', trigger: 'blur'},
        ],

      },
      woRule: {
        remark: [
          {type: 'string', max: 1000, message: '内容不能超过1000个字', trigger: 'blur'}
        ],
        payAmount: [
          {type: 'number', required: true, min: 0, max: 100000, message: '请填写正确的支付金额', trigger: 'blur'},
        ],
      },
      callRecordData: [],
      userModal: null,
      studentNature: [],
      studyExperience: [],
      hobby: [],
      englishLevel: [],
      tchRequirement: [],
      queryParam: {
        intentLevel: '',
        uid: '',
        mobile: '',
      },
      callRecordTitle: [
        {
          title: '通话时间',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('p', {style: {margin: '0'}}, params.row.beginTime),
              h('p', {style: {margin: '0'}}, '通话时长:' + this.formatRecordTime(params.row.hold))
            ])
          }
        },
        {
          title: '员工',
          key: 'callerId',
          align: 'center',
        },
        {
          title: '通话录音',
          render: (h, params) => {
            const audioUrl = params.row.recordUrl
            if (audioUrl) {
              if (audioUrl === '失败') {
                return h('span', '无录音')
              }
              return h('audio', {
                attrs: {
                  src: audioUrl,
                  controls: true // 显示播放控件
                },
                style: {
                  width: '100%'
                }
              })
            } else {
              return h('span', '无录音')
            }
          }
        },
        {
          title: '备注',
          align: 'center',
          key: 'content',
        },
      ],
      visible: this.value,
      userRule: {
        age: [
          {pattern: /^[0-9]+$/, message: '只能输入数字', trigger: 'blur'}
        ],
      },
      followRule: {
        traceStatus: [
          {required: true, message: '请选择状态', trigger: 'blur'}
        ],
        traceItem: [
          {type: 'integer', required: true, message: '请选择状态', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '内容不能为空', trigger: 'blur'}
        ],
      },
      followData: [],
      stageReportData: [],
      appVersionData: {},
      woFollowTitle: [
        {
          title: '时间',
          width: 100,
          key: 'gmtCreate',
        },
        {
          title: '状态',
          width: 110,
          render: (h, params) => {
            let woStatus = params.row.newStatus
            let woStatusEnum = $constant.getEnum($constant.woStatus, woStatus)
            return h('span', woStatusEnum && woStatusEnum.text)
          }
        },

        {
          title: '备注',
          key: 'remark',
        },
        {
          title: '角色',
          width: 100,
          key: 'roleName',
        },
        {
          title: '处理人',
          width: 100,
          key: 'creatorName',
        },
      ],
      followtitle: [
        {
          title: '时间',
          width: 100,
          key: 'gmtCreate',
        },
        {
          title: '状态',
          width: 110,
          render: (h, params) => {
            if (params.row.traceStatus == 100 || params.row.creatorName === '注册备注') return h('span', '注册备注')
            let traceStatus = params.row.traceStatus
            let traceStatusEnum = $constant.getEnum($constant.traceStatus, traceStatus)
            return h('span', traceStatusEnum && traceStatusEnum.text)
          }
        },
        {
          title: 'follow up选项',
          key: 'traceItem',
          width: 90,
          render: (h, params) => {
            let traceItem = params.row.traceItem
            let traceItemEnum = $constant.getEnum($constant.traceItem, traceItem)
            return h('span', traceItemEnum && traceItemEnum.text)
          }
        },
        {
          title: '内容',
          key: 'content',
        },
        {
          title: '下次联系时间',
          width: 100,
          key: 'nextContactTime',
        },
        {
          title: '处理人',
          width: 100,
          key: 'creatorName',
        },
      ],
      stageReportTitle: [
        {
          title: '老师ID/姓名',
          key: 'tchNameId',
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.tchNameId,
              score: row.monthRankScore
            })
          }
        },
        {
          title: '报告对应课节',
          key: 'lessonNum',
        },
        {
          title: '外管',
          key: 'studyName',
        },
        {
          title: '学导',
          key: 'tutorName',
        },
        {
          title: '阶段测评报告',
          render: (h, params) => {
            let row = params.row
            if (row.reportDoc !== '') {
              return h('div', [
                h('a', {on: {click: () => this.lookRerot(row.id)}}, '查看与编辑'),
                // h('pre', {class: 'f'}),
                //  h('a', {on: {click: () => this.dowlode(row.reportDoc)}}, '下载')
              ])
            }
          }
        },
        {
          title: '添加时间',
          key: 'gmtCreate',
        },
        {
          title: '添加人',
          key: 'creatorName',
        },
        {
          title: '状态',
          render: (h, params) => {
            let row = params.row
            if (row.status === 1) {
              return h('span', '待审核')
            } else {
              return h('span', '已通过')
            }
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            let row = params.row
            if (row.status === 2) {
              return h('span', '')
            } else {
              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      this.editReport(row.id, 2)
                    }
                  }
                }, '通过'),
              ])
            }
          }
        },
      ],
      recommendTitle: [
        {
          title: '老师ID/姓名',
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.tchId + '-' + row.firstName + ' ' + row.lastName,
              score: row.monthRankScore
            })
          }
        },
        {
          title: '类型',
          render: (h, params) => {
            let row = params.row
            let cons = this.$constant.getEnum(this.$constant.teacherCategory, row.category)
            return h('span', cons && cons.text)
          }
        },
        {
          title: '授课类型',
          render: (h, params) => {
            let row = params.row
            let cons = this.$constant.getEnum(this.$constant.tchType, row.tchType)
            return h('span', cons && cons.text)
          }
        },
        {
          title: '性别',
          render: (h, params) => {
            let row = params.row
            let cons = this.$constant.getEnum(this.$constant.sex, row.sex)
            return h('span', cons && cons.text)
          }
        },
        {
          title: '口音',
          render: (h, params) => {
            let row = params.row
            let cons = this.$constant.getEnum(this.$constant.accent, row.accent)
            return h('span', cons && cons.text)
          }
        },
        {
          title: '年龄',
          key: 'age',
        },
        {
          title: '推荐理由',
          key: 'reason',
        },
        {
          title: '推荐人',
          key: 'recommendName',
        },
        {
          title: '取消人',
          key: 'cancelName',
        },
        {
          title: '操作',
          render: (h, params) => {
            let row = params.row
            if (row.status === 1) {
              return h('a', {on: {click: () => this.cancelRecommend(row.id)}}, '取消推荐')
            } else {
              return h('span', '已取消')
            }
          }
        },
      ],
      fundPackageTitle: [
        {
          title: '订单号',
          width: 100,
          key: 'orderId'
        },
        {
          title: '姓名',
          width: 100,
          key: 'nickname'
        },
        {
          title: '渠道',
          width: 90,
          render: (h, params) => {
            let row = params.row
            let channel = row.channel
            let channelEnum = $constant.getEnum($constant.orderChannel, channel)
            return h('div', channelEnum && channelEnum.text)
          },
          key: 'channel'
        },
        {
          title: '订单权益',
          width: 250,
          render: (h, params) => {
            let row = params.row
            if (row.tchChannel === 1) {
              return h('div', [
                h('p', '外教课时:' + (row.num || 0)),
                h('p', '中教课时:' + (row.chineseNum || 0)),
                h('p', '陪练课时:' + (row.partnerNum || 0)),
                h('p', '赠送课时:' + (row.discountNum || 0)),
                h('p', '直播课时:' + (row.livingNum || 0)),
                h('p', '辅修课时:' + (row.minorNum || 0)),
                h('p', '请假次数:' + (row.leaveNum || 0)),
                h('p', '补课次数:' + (row.makeupLessonNum || 0))
              ])
            }
            let attrs = []
            row.classHourList.forEach(item => {
              attrs.push(h('p', item.channel + ':' + (item.num > 0 ? item.num : '')))
            })
            return h('div', attrs)
          }
        },
        {
          title: '套餐金额',
          width: 160,
          render: (h, params) => {
            let row = params.row
            return h('div', [
              h('p', {style: {color: '#2d8cf0'}}, '套餐金额:' + $numeral(row.amount).format('0,0.00')),
              h('p', '优惠金额:' + $numeral(row.discount).format('0,0.00')),
              h('p', '实付金额:' + $numeral(row.payAmount).format('0,0.00')),
              h('p', {style: {color: 'red'}}, '已付金额:' + $numeral(row.hasPayAmount).format('0,0.00'))])
          }
        },
        {
          title: '订单状态',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let state = params.row.state
            let stateEnum = $constant.getEnum($constant.fundPackageState, state)
            return h('div', stateEnum && stateEnum.text)
          }
        },
        {
          title: '支付方式',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let payWay = params.row.payWay
            let stateEnum = $constant.getEnum($constant.payWayNew, payWay)
            return h('div', stateEnum && stateEnum.text)
          }
        },
        {
          title: '创建时间',
          width: 170,
          align: 'center',
          render: (h, params) => {
            let createTime = params.row.createTime
            return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm'))
          }
        },
        {
          title: '版本号',
          width: 80,
          render: (h, params) => {
            let num = ['版本一', '版本二', '版本三', '版本四']
            return h('div', params.row.version === -1 ? '-' : num[params.row.version - 1])
          }
        },
        {
          title: '合同状态',
          width: 100,
          render: (h, params) => {
            let status = params.row.contractStatus === -1 ? '-' : $constant.getEnum($constant.contractStatus, params.row.contractStatus).text
            return h('div', status)
          }
        },
        {
          title: '创建人',
          width: 150,
          render: (h, params) => {
            let creatorId = params.row.creatorId
            let creatorName = params.row.creatorName
            return h('div', [h('span', creatorId), h('span', '-'), h('span', creatorName)])
          }
        },
        {
          title: '操作',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.contractStatus === 2) {
              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      self.showModel('version', row)
                    }
                  }
                }, '修改版本号'),
                h('br'),
                h('a', {
                  on: {
                    click: () => {
                      self.showModel('contractStatus', row)
                    }
                  }
                }, '修改合同状态')
              ])
            } else {
              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      self.onPreview(row)
                    }
                  }
                }, '查看合同'),
                h('br'),
                h('a', {
                  on: {
                    click: () => {
                      self.showModel('version', row)
                    }
                  }
                }, '修改版本号'),
                h('br'),
                h('a', {
                  on: {
                    click: () => {
                      self.showModel('contractStatus', row)
                    }
                  }
                }, '修改合同状态')
              ])
            }
          }
        }
      ],
      uid: null,
      parm: {},
      courseTypeTitle: [
        {
          title: '课程类型',
          width: 150,
          render: (h, params) => {
            let courseType = params.row.courseType
            if (courseType && courseType === 1) {
              return h('span', '外教课')
            } else if (courseType && courseType === 2) {
              return h('span', '中教课')
            } else if (courseType && courseType === 8) {
              return h('span', '陪练课')
            } else {
              return h('span', '')
            }
          }
        },
        {
          title: '订单总课时',
          width: 200,
          render: (h, params) => {
            let row = params.row
            let totalOrderNum = row.totalOrderNum
            totalOrderNum = totalOrderNum > 0 ? totalOrderNum : 0
            let totalPresenterNum = row.totalPresenterNum
            totalPresenterNum = totalPresenterNum > 0 ? totalPresenterNum : 0
            let totalNum = row.totalOrderNum + row.totalPresenterNum
            totalNum = totalNum > 0 ? totalNum : 0
            return h('div', [
              h('p', '套餐课时:' + totalOrderNum),
              h('p', '赠送课时:' + totalPresenterNum),
              h('p', {style: {color: 'red'}}, '订单总课时:' + totalNum)])
          }
        },
        {
          title: '手动添加课时',
          width: 100,
          render: (h, params) => {
            let totalAddNum = params.row.totalAddNum
            totalAddNum = totalAddNum > 0 ? totalAddNum : 0
            return h('span', totalAddNum)
          }
        },
        {
          title: '手动减少课时',
          width: 100,
          render: (h, params) => {
            let totalReduceNum = params.row.totalReduceNum
            totalReduceNum = totalReduceNum > 0 ? totalReduceNum : 0
            return h('span', totalReduceNum)
          }
        },
        {
          title: '总课时',
          width: 100,
          render: (h, params) => {
            let totalNum = params.row.totalNum
            totalNum = totalNum > 0 ? totalNum : 0
            return h('span', totalNum)
          }
        },
        {
          title: '正常消耗',
          width: 100,
          render: (h, params) => {
            let endNum = params.row.endNum
            endNum = endNum > 0 ? endNum : 0
            return h('span', endNum)
          }
        },
        {
          title: '总剩余课时',
          width: 100,
          render: (h, params) => {
            let row = params.row
            let num = row.totalNum - row.endNum
            num = num >= 0 ? num : 0
            return h('span', num)
          }
        },
        {
          title: '锁定课时',
          width: 100,
          render: (h, params) => {
            let row = params.row
            let num = row.lockNum
            num = num >= 0 ? num : 0
            return h('span', num)
          }
        },
        {
          title: '剩余可用',
          width: 100,
          render: (h, params) => {
            let row = params.row
            let num = row.totalNum - row.endNum - row.lockNum
            num = num >= 0 ? num : 0
            return h('span', num)
          }
        },
        {
          title: '剩余请假次数',
          width: 150,
          render: (h, params) => {
            let row = params.row
            let num = row.remainingLeaveNum
            num = num >= 0 ? num : ''
            return h('span', num)
          }
        },
        {
          title: '剩余补课次数',
          width: 150,
          render: (h, params) => {
            let row = params.row
            let num = row.remainingMakeupNum
            num = num >= 0 ? num : ''
            return h('span', num)
          }
        },
        {
          title: '总试听课次数',
          width: 150,
          render: (h, params) => {
            let row = params.row
            let num = row.demoClassHourNum
            num = num >= 0 ? num : ''
            return h('span', num)
          }
        },
        {
          title: '剩余试听课次数',
          width: 150,
          render: (h, params) => {
            let row = params.row
            let num = row.demoClassHourResidueNum
            num = num >= 0 ? num : ''
            return h('span', num)
          }
        },
        /*
        {
          title: '操作',
          width: 100,
          render: (h, params) => {
            let courseType = params.row.courseType
            return h('a', {on: {click: () => {
              this.openUserClassHourModal(courseType)
            }}}, '加减课时')
          }
        }
        */
      ],
      courseHourTitle: [
        {
          title: '数量(节|次)',
          width: 100,
          align: 'center',
          key: 'num'
        },
        {
          title: '已消耗',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('span', {style: {color: 'red'}}, params.row.consumeNum)
          }
        },
        {
          title: '锁定(已选)',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('span', {style: {color: 'orange'}}, params.row.lockNum)
          }
        },
        {
          title: '剩余可用',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('span', {style: {color: 'green'}}, params.row.num - params.row.consumeNum - params.row.lockNum)
          }
        },
        {
          title: '类型',
          width: 135,
          align: 'center',
          key: 'type'
        },
        {
          title: '权益说明',
          width: 135,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.taskNum > 0) {
              return [
                h('span', row.channel + '（'),
                h('span', {style: {color: 'blue'}}, row.taskNum),
                h('span', '）')]
            }
            return row.channel
          }
        },
        {
          title: '生效时间',
          width: 135,
          align: 'center',
          key: 'gmtCreate'
        },
        {
          title: '有效期(天)',
          width: 135,
          align: 'center',
          key: 'effectDays'
        },
        {
          title: '到期时间',
          width: 135,
          align: 'center',
          key: 'expireTime'
        },
        {
          title: '操作人)',
          width: 135,
          align: 'center',
          key: 'creatorName'
        },
      ],
      bookLessonTitle: [
        {
          title: '老师ID/姓名',
          width: 180,
          render: (h, params) => {
            let row = params.row
            let isChange = ''
            if (row.isNewTch === 1) {
              isChange = '(替)'
            }
            return renderTchNameWithScore(h, {
              text: row.tchId + '-' + row.tchFirstName + ' ' + row.tchLastName + isChange,
              score: row.monthRankScore,
              onClick: () => this.openNewLessonModal(row.tchId, row.tchFirstName + row.tchLastName)
            })
          }
        },
        {
          title: '课程信息',
          width: 130,
          render: (h, params) => {
            let row = params.row
            let lsnType = row.lsnType
            let typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType)
            let courseType = row.courseType
            let courseTypeEnum = $constant.getEnum($constant.courseType, courseType)
            let cType = courseTypeEnum && courseTypeEnum.text
            if (cType) {
              cType = '课程类别:' + cType
            } else {
              cType = ''
            }
            return h('div', [
              h('p', row.id),
              h('p', row.lessonTitle),
              h('p', {style: {'font-size': '12px', color: 'red'}}, cType),
              h('p', {style: {'font-size': '12px', color: '#2d8cf0'}}, '课程类型:' + (typeEnum && typeEnum.text))])
          }
        },
        {
          title: '上课时间',
          width: 110,
          render: (h, params) => {
            let lsnBeginTime = params.row.lsnBeginTime
            let week = $moment(lsnBeginTime, 'X').day()
            return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $constant.weekZh[week])
          }
        },
        {
          title: '时长',
          align: 'center',
          width: 60,
          key: 'courseTime',
          render: (h, params) => {
            let lsnBeginTime = params.row.lsnBeginTime
            let lsnEndTime = params.row.lsnEndTime
            return h('span', (lsnEndTime - lsnBeginTime) / 60)
          }
        },
        {
          title: '教室',
          width: 120,
          render: (h, params) => {
            let row = params.row
            let classType = row.classType
            let typeEnum = $constant.getEnum($constant.classType, classType)
            return h('div', {style: {'font-size': '14px'}}, [
              h('span', typeEnum && typeEnum.text),
              h('span', ' - '),
              h('br'),
              h('span', row.courseId)
            ])
          }
        },
        {
          title: '状态',
          width: 110,
          render: (h, params) => {
            let row = params.row
            let remark = row.remark
            let lsnSelStatus = row.lsnSelStatus
            let statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus)
            let absentArr = []
            if (row.tchAbsent === 1) {
              absentArr.push('老师缺席')
            }
            if (row.stdAbsent === 1) {
              absentArr.push('学生缺席')
            }
            return h('div', {style: {'font-size': '14px'}}, [
              h('span', statusEnum && statusEnum.text),
              absentArr.length ? h('span', {style: {'font-size': '13px', color: 'red'}}, ' [' + absentArr.join(' ') + ']') : null,
              h('br'),
              h('span', {style: {'font-size': '13px', color: 'red'}}, remark)
            ])
          }
        },
        {
          title: '创建操作人',
          width: 180,
          key: 'creatorName',
          render: (h, params) => {
            let row = params.row
            let studyAdviserNickname = row.studyAdviserNickname
            if (!studyAdviserNickname) {
              studyAdviserNickname = '未分配'
            }
            let adviserNickname = row.adviserNickname
            if (!adviserNickname) {
              adviserNickname = '未分配'
            }
            let tchStudyName = row.tchStudyName
            if (!tchStudyName) {
              tchStudyName = '未分配'
            }
            return h('div', {style: {'font-size': '13px'}}, [
              h('p', '学导:' + studyAdviserNickname),
              h('p', '课顾:' + adviserNickname),
              h('p', '外管:' + tchStudyName),
              h('p', '创建人：' + row.creatorName),
              h('p', '最后操作人：' + row.adminNickname)])
          }
        },
        {
          title: '操作时间',
          width: 110,
          key: 'gmtModified',
        },
        {
          title: '排课时间',
          width: 110,
          render: (h, params) => {
            let lsnBeginTime = params.row.lessonOpenTime
            return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm'))
          }
        },
        {
          title: '评价',
          width: 130,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let bookTchFeedbackUid = row.bookTchFeedbackUid
            let spanArr = []
            let version = row.version
            if (bookTchFeedbackUid) {
              let obj = h('a', {
                on: {
                  click: () => {
                    // console.log(version)
                    this.openedId = row.id
                    // this.studentWriteReviewDemoModal = true  // 新版本demo课评价
                    // return
                    if (version === 0) {
                      if (row.lsnType === 1) {
                        this.showBookTchScoreFeedbackModal = true
                      } else {
                        this.showBookTchFeedbackModal = true
                      }
                    } else if (version === 1) {
                      if (row.lsnType === 1) {
                        this.studentWriteReviewDemoModal = true  // 新版本demo课评价
                      } else if (row.lsnType === 2) {
                        if (row.stageSummary) {
                          this.studentWriteReviewFinishLevelModal = true // 新版本阶段课程完成
                        } else {
                          this.studentWriteReviewRegularModal = true // 新版本常规课程评价
                        }
                      }
                    } else if (version === 2) {
                      if (row.lsnType === 1) {
                        this.studentWriteReviewDemoV2Modal = true  // 新版本demo课评价
                      } else if (row.lsnType === 2) {
                        if (row.stageSummary) {
                          this.studentWriteReviewFinishLevelV2Modal = true // 新版本阶段课程完成
                        } else {
                          this.studentWriteReviewRegularV2Modal = true // 新版本常规课程评价
                        }
                      }
                    }
                  }
                }
              },
            '老师对学生评价')
              let her = 'https://test-h5.kouyujie.cn/std-report/report.html?bookLessonId=' + row.id
              if (this.$appConfig.active === 'prod') {
                her = 'https://h5.speakstreet.cn/std-report/report.html?bookLessonId=' + row.id
              }
            // 添加预览链接
              let previewLink = h('a', {
                attrs: {
                  href: her,
                  target: '_blank'
                },
                style: {
                  marginLeft: '10px'
                }
              }, '预览')
              spanArr.push(obj)
              spanArr.push(h('br'))
              if (row.lsnType === 1 && version === 2) {
                spanArr.push(h('br'))
                spanArr.push(previewLink)
                spanArr.push(h('br'))
              }
            }
            let bookUserFeedbackId = row.bookUserFeedbackId
            let bookUserFeedbackStar = row.bookUserFeedbackStar
            if (bookUserFeedbackId) {
              let obj2 = h('div', [
                h('Rate', {
                  props: {
                    disabled: true,
                    count: bookUserFeedbackStar,
                    value: bookUserFeedbackStar
                  },
                  style: {'font-size': '12px'}
                }),
                h('br'),
                h('a', {
                  on: {
                    click: () => {
                      this.openedId = row.id
                      this.showBookUserFeedbackModal = true
                    }
                  }
                },
                '学生对老师评价')
              ])
              spanArr.push(obj2)
            }
            if (spanArr.length === 0
  ) {
              return h('div', {style: {color: 'red'}}, '未评论')
            }
            return h('div', {style: {'font-size': '13px', color: 'red'}}, spanArr)
          }
        },
        {
          title: '上课情况',
          width:
      100,
          align:
      'center',
          render:
      (h, params) => {
        return h('a', {
          on: {
            click: () => {
              this.openedId = params.row.id
              this.showClassMemberTimeModal = true
            }
          }
        },
          '查看')
      }
        },
        {
          title: '监课/回放',
          width:
      100,
          align:
      'center',
          render:
      (h, params) => {
        if (params.row.liveUrl) {
          return h('a', {
            on: {
              click: () => {
                window.open(params.row.liveUrl)
              }
            }
          },
            '进入')
        } else {
          return h('span')
        }
      }
        },
    /*
    {
      title: '监课记录',
      width: 80,
      align: 'center',
      render: (h, params) => {
        let row = params.row
        let lsnSelStatus = row.lsnSelStatus
        if (lsnSelStatus === 1) {
          return h('span', '')
        }
        let isMonitorLessonRecord = row.isMonitorLessonRecord
        if (isMonitorLessonRecord) {
          return h('a', {on: {
            click: () => {
              this.openedId = row.id
              this.showMonitorLessonRecordListModal = true
            }
          }}, '查看')
        }
        return h('span', { style: { color: 'red' } }, '未记录')
      }
    },
    */
        {
          title: '操作',
          align:
      'center',
          width:
      80,
          render:
      (h, params) => {
        let row = params.row
        let id = parseInt(row.id)
        let lsnType = row.lsnType
        let lessonTitle = row.lessonTitle
        let lsnBeginTime = row.lsnBeginTime
        let btn = []
        btn.push(h('Dropdown-item', {props: {name: 'reloadClassIn'}}, '手动生成ClassIn ID'))
        btn.push(h('Dropdown-item', {props: {name: 'lessonUrl'}}, '课程链接'))

        if (row.lsnSelStatus === 1) {
          let time = new Date().getTime()
          if (lsnBeginTime * 1000 - time >= 600000) {
            btn.push(h('Dropdown-item', {props: {name: 'changeLesson'}}, '调课件'))
          }
          btn.push(h('Dropdown-item', {props: {name: 'userLeave'}}, '学生请假'))
          // btn.push(h('Dropdown-item', {props: {name: 'tchLeave'}}, '老师请假'))
          if (row.lsnSelStatus !== 2 && lsnBeginTime * 1000 > time) {
            btn.push(h('Dropdown-item', {props: {name: 'cancelLesson'}}, '取消课程'))
          }
          if (row.isRecordScreen === 1) {
            btn.push(h('Dropdown-item', {props: {name: 'closeRecordScreen'}}, '关闭录屏'))
          } else {
            btn.push(h('Dropdown-item', {props: {name: 'openRecordScreen'}}, '开启录屏'))
          }
          if (lsnBeginTime * 1000 > time + 20 * 60 * 1000) {
            // btn.push(h('Dropdown-item', {props: {name: 'changeTeacherOnly'}}, '更换老师/时间'))
          }
        }
        if (row.lsnSelStatus === 3) {
          btn.push(h('Dropdown-item', {props: {name: 'userAbsent'}}, '学生旷课'))
          btn.push(h('Dropdown-item', {props: {name: 'tchAbsent'}}, '老师旷课'))
          if (row.liveUrl) {
            btn.push(h('Dropdown-item', {props: {name: 'viewRecordScreen'}}, '查看录屏'))
          }
          btn.push(h('Dropdown-item', {props: {name: 'balance'}}, '课程结算'))
          btn.push(h('Dropdown-item', {props: {name: 'rejectBalance'}}, '拒绝结算'))
        }
        btn.push(h('Dropdown-item', {props: {name: 'monitorLesson'}}, '添加监课记录'))

        return h('div', [
          h('Dropdown', {
            props: {
              transfer: true,
              trigger: 'click',
              placement: 'bottom-end'
            },
            on: {
              'on-click': (name) => {
                if (name === 'reloadClassIn') {
                  this.onReloadClassIn(row)
                } else if (name === 'lessonUrl') {
                  window.open('https://medias.kouyujie.cn/' + row.filePath)
                } else if (name === 'changeLesson') {
                  this.lessonOpened = row
                  this.showChangeLessonModal = true
                } else if (name === 'userLeave') {
                  this.openId = id
                  this.lessonTitle = lessonTitle
                  this.lsnBeginTime = lsnBeginTime
                  this.showUserOneLeaveModal = true
                  // this.onUserLeave(id)
                } else if (name === 'tchLeave') {
                  this.openedId = id
                  this.lessonTitle = lessonTitle
                  this.lsnBeginTime = lsnBeginTime
                  this.showTchLessonLeaveModal = true
                  //                        this.onTchLeave(id)
                } else if (name === 'cancelLesson') {
                  this.openedId = id
                  this.lsnType = lsnType
                  this.showLessonCancelModal = true
                } else if (name === 'userAbsent') {
                  this.onUserAbsent(row)
                } else if (name === 'tchAbsent') {
                  this.onTchAbsent(row)
                } else if (name === 'monitorLesson') {
                  this.openedId = id
                  this.showMonitorLessonRecordModal = true
                } else if (name === 'closeRecordScreen') {
                  this.closeRecordScreen(row)
                } else if (name === 'openRecordScreen') {
                  this.openRecordScreen(row)
                } else if (name === 'viewRecordScreen') {
                  this.viewRecordScreen(row)
                } else if (name === 'balance') {
                  this.openedId = id
                  this.showBalanceModal = true
                } else if (name === 'rejectBalance') {
                  this.openedId = id
                  this.showRejectBalanceModal = true
                } else if (name === 'changeTeacherOnly') {
                  this.tempLessonUser = row
                  this.showSearchChangeTchModal = true
                  this.changeTeacherOnly = true
                  this.optType = 2
                }
              }
            }
          }, [
            h('a', [
              h('span', '更多 '),
              h('Icon', {props: {type: 'ios-arrow-down'}})
            ]),
            h('Dropdown-menu', {slot: 'list'}, btn)
          ])
        ])
      }
        }
      ],
      bookLessonReset: false,
      showBookUserFeedbackModal:
    false,
      showClassMemberTimeModal:
    false,
      showBookTchFeedbackModal:
    false,
      showBookTchScoreFeedbackModal:
    false,
      showMonitorLessonRecordListModal:
    false,
      showChangeLessonModal:
    false,
      UserOneLeaveModal:
    false,
      showUserOneLeaveModal:
    false,
      showChangeLClassTypeModal:
    false,
      showMonitorLessonRecordModal:
    false,
      showTchLessonLeaveModal:
    false,
      showLessonCancelModal:
    false,
      showBalanceModal:
    false,
      showRejectBalanceModal:
    false,
      openedId:
    null,
      tempLessonUser:
      {

      },
      showSearchChangeTchModal: false,
      changeTeacherOnly:
    true,
      lsnType:
    null,
      openId:
    null,
      lessonOpened:
      {
      },
      lessonTitle: '',
      lsnBeginTime:
    null,
      reloadWithPage:
    0,
      editUser:
    false,
      lessonParams:
      {
        date: dates.today(),
        studyAdviserId:
      '',
        keywords:
      '',
        totalCount:
      0,
        isAudition:
      null,
        category:
      null,
        tchType:
      null,
        accent:
      null,
        sex:
      null,
        backPath:
      ''
      },
      showUserClassHourModal: false,
      courseType:
    null,
      disableTimeParams:
      {
        disableWeek: null,
        disableWeekStr:
      null,
        disableStartTime:
      null,
        disableStartTimeStr:
      null,
        disableEndTime:
      null,
        disableEndTimeStr:
      null,
      },
      disableTimeList: [],
      woVersion:
    null,
      woDisable:
    false
    }
  },
  computed: {
    appVersionTypeText () {
      let type = this.appVersionData.type
      if (type === 1) return 'iOS'
      if (type === 2) return '安卓'
      return '-'
    },
    detailTabsReady () {
      return this.woChecked && this.userInfoChecked
    },
    fixedRequireLines () {
      return this.splitFixedRequire(this.fixedClassRequire)
    },
    fixedRequireEnLines () {
      return this.splitFixedRequire(this.fixedClassRequireEn)
    }
  },
  methods: {
    loadMonthRankScoresFor (rows, idKey) {
      idKey = idKey || 'tchId'
      if (!rows || !rows.length) {
        return
      }
      const ids = []
      rows.forEach(function (row) {
        let id = row[idKey]
        if ((id == null || id === '') && row.tchNameId) {
          const matched = String(row.tchNameId).match(/^(\d+)/)
          if (matched) {
            id = Number(matched[1])
            row._scoreTchId = id
          }
        }
        if (id != null && id !== '') {
          ids.push(id)
        }
      })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, rows, idKey, 'monthRankScore', map)
        rows.forEach(function (row) {
          if (row.monthRankScore == null && row._scoreTchId != null) {
            let score = map[row._scoreTchId]
            if (score == null) {
              score = map[String(row._scoreTchId)]
            }
            if (score != null) {
              self.$set(row, 'monthRankScore', score)
            }
          }
        })
      })
    },

    handleMultiLevelScheduleChange (value) {
      this.formData.stars = value ? 2 : 1
    },
    handleSelfBookingChange (value) {
      this.formData.tchIdCopy = value ? 1 : 0
    },
    handleNoStudyAdviserRemindChange (value) {
      this.formData.noStudyAdviserRemind = value ? 1 : 0
    },
    handleMobileRemindChange (value) {
      this.formData.mobileRemind = value ? 1 : 0
    },
    handleRemarkMobileRemindChange (value) {
      this.formData.remarkMobileRemind = value ? 1 : 0
    },
    handleBeforeClassCallChange (value) {
      this.formData.beforeClassCall = value ? 1 : 0
    },
    handleHarvardForeignAuthChange (value) {
      if (!this.harvardForeignLoaded) {
        return
      }
      let prev = this.harvardForeignEnabled
      this.harvardForeignEnabled = value
      this.$http.post('/user/harvardForeignAuth/save', {
        uid: this.formData.uid,
        enabled: value ? 1 : 0
      }).then(res => {
        if (res) {
          this.$Message.success('修改成功')
        } else {
          this.harvardForeignEnabled = prev
          this.$Message.error('修改失败')
        }
      }).catch(() => {
        this.harvardForeignEnabled = prev
        this.$Message.error('修改失败')
      })
    },
    handleEnabledRuleChange (value) {
      // 当开关切换时，调用接口更新状态
      this.$http.post('/user/updateEnabledRule', {
        uid: this.formData.uid,
        enabledRule: value
      }).then(res => {
        if (res) {
          this.$Message.success('修改成功')
        } else {
          // 如果接口调用失败，恢复原来的值
          this.formData.enabledRule = !value
          this.$Message.error('修改失败')
        }
      }).catch(() => {
        // 如果接口调用失败，恢复原来的值
        this.formData.enabledRule = !value
        this.$Message.error('修改失败')
      })
    },
    handleSummativeEnabledChange (value) {
      if (!this.summativeLoaded) {
        return
      }
      if (value && !this.summativeBlueprintId) {
        this.$Message.warning('请先选择阶段测蓝图')
        this.summativeEnabled = true
        this.$nextTick(() => {
          this.summativeEnabled = false
        })
        return
      }
      let prevEnabled = this.summativeEnabled
      this.summativeEnabled = value
      this.saveStudentSummative({prevEnabled: prevEnabled})
    },
    handleSummativeBlueprintChange (id) {
      if (!this.summativeLoaded) {
        return
      }
      if (id === this.summativeBlueprintId) {
        return
      }
      let prevBlueprintId = this.summativeBlueprintId
      this.summativeBlueprintId = id
      this.saveStudentSummative({prevBlueprintId: prevBlueprintId})
    },
    saveStudentSummative (rollback) {
      let self = this
      self.$http.post('/mex/student-summative/save', {
        uid: self.formData.uid || self.uid,
        enabled: self.summativeEnabled ? 1 : 0,
        blueprintId: self.summativeBlueprintId
      }).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('修改成功')
        } else {
          self.rollbackSummativeSave(rollback)
          self.$Message.error(res.msg || '修改失败')
        }
      }).catch(function () {
        self.rollbackSummativeSave(rollback)
        self.$Message.error('修改失败')
      })
    },
    rollbackSummativeSave (rollback) {
      if (!rollback) {
        return
      }
      if (rollback.prevEnabled !== undefined) {
        this.summativeEnabled = rollback.prevEnabled
      }
      if (rollback.prevBlueprintId !== undefined) {
        this.summativeBlueprintId = rollback.prevBlueprintId
      }
    },
    formatRecordTime (time) {
      let sTime = time
      let mTime = 0
      let hTime = 0
      if (sTime > 60) {
        mTime = parseInt(sTime / 60)
        sTime = parseInt(sTime % 60)
        if (mTime > 60) {
          hTime = parseInt(mTime / 60)
          mTime = parseInt(mTime % 60)
        }
      }
      if (hTime === 0) {
        if (mTime === 0) {
          return sTime + '秒'
        }
        return mTime + '分' + sTime + '秒'
      }
      if (mTime === 0) {
        return sTime + '秒'
      }
      return hTime + '小时' + mTime + '分' + sTime + '秒'
    },
    showModel (type, data) {
      if (type == 'version') {
        this.fundPackageId = data.id
        this.showVersionModel = true
      } else {
        this.fundPackageId = data.id
        this.showContractStatusModel = true
      }
    },
    saveVersion () {
      let self = this
      self.$http.post('/fundPackage/upateVersion', {id: this.fundPackageId, version: this.needversion}).then(res => {
        if (res) {
          self.$Message.success('处理成功!')
          this.reload_fundPackage = new Date().getTime()
        }
        this.showVersionModel = false
      })
    },
    saveContractStatus () {
      let self = this
      self.$http.post('/fundPackage/upateContractStatus', {
        id: this.fundPackageId,
        contractStatus: this.needContractStatus
      }).then(res => {
        if (res) {
          self.$Message.success('处理成功!')
          this.reload_fundPackage = new Date().getTime()
        }
        this.showContractStatusModel = false
      })
    },
    openUserClassHourModal () {
      this.showUserClassHourModal = true
    },
    onUserAbsent (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>学生</b> 旷课？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          self.$http.post('/bookLesson/userAbsent', {id: row.id}).then(res => {
            if (res) {
              self.search()
              self.$Message.success('处理成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    onTchAbsent (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认 <b>老师</b> 旷课？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          self.$http.post('/bookLesson/tchAbsent', {id: row.id}).then(res => {
            if (res) {
              self.search()
              self.$Message.success('处理成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    closeRecordScreen (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认<b>关闭</b>录屏？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          self.$http.post('/bookLesson/updateRecordScreen', {openedId: row.id, isRecordScreen: 0}).then(res => {
            if (res) {
              self.search()
              self.$Message.success('处理成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },

    formateCountber (Count) {
      Count = Count + ''
      let index = Count.indexOf('.')
      if (index > 0) {
        Count = Count.substring(0, index + 3)
      }
      return Count
    },

    getWodetail (id) {
      let self = this
      self.$http.post('/sale/wo/detail?studentId=' + id).then(function (res) {
        const data = res.data
        if (data) {
          self.showWo = true
          self.woFormData.saleWo = data.saleWo
          self.woFormData.saleWo.woStatus = self.$constant.getEnum(self.$constant.woStatus, data.saleWo.status)
          self.woFormData.saleWo.orderChannel = self.$constant.getEnum(self.$constant.orderChannel, data.saleWo.fundChannel)
          self.woFormData.follows = data.follows
          const status = self.woFormData.saleWo.status
          self.woVersion = data.saleWo.version + ''
          self.woReadonly = status !== 'UN_SUBMITTED' && status !== 'REJECTED'
          self.woDisable = status !== 'UN_SUBMITTED' && status !== 'REJECTED'

          self.disableTimeList = data.saleWo.disableTimeList
          if (self.disableTimeList && self.disableTimeList !== '') {
            self.disableTimeList.forEach(item => {
              item.disableWeek = item.week
              item.disableWeekStr = self.$constant.weekZh[item.week]
              item.disableStartTime = self.$dateUtil.getSecondByHm(item.startTime)
              item.disableStartTimeStr = item.startTime
              item.disableEndTime = self.$dateUtil.getSecondByHm(item.endTime)
              item.disableEndTimeStr = item.endTime
            })
          } else {
            self.disableTimeList = []
          }
        }
        self.woChecked = true
      }).catch(function () {
        self.woChecked = true
      })
    },
    submitWoData () {
      let self = this
      self.woSubmitLoading = true
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认<b>提交</b>工单？',
        width: 300,
        loading: true,
        onCancel: () => {
          self.woSubmitLoading = false
        },
        onOk: () => {
          self.$Modal.remove()
          self.$refs.woFormData.validate((valid) => {
            if (!valid) {
              self.$Message.warning('信息输入错误!')
              self.woSubmitLoading = false
              return
            }
            let data = this.woFormData.saleWo
            let params = {}
            params.studentId = data.studentId
            params.payAmount = data.payAmount
            params.adviserName = data.adviserName
            params.studyAdviserName = data.studyAdviserName
            params.teacherName = data.teacherName
            params.woStatus = data.woStatus
            params.remark = data.remark
            params.classOpeningTime = dateFormat(data.classOpeningTime, 'YYYY-MM-DD HH:mm:ss')
            if (self.woVersion && self.woVersion !== 'undefined') {
              params.version = self.woVersion
            }
            if (self.disableTimeList) {
              params.disableTimeList = self.disableTimeList
            }
            self.$http.post('/sale/wo/submit', {}, {
              transformRequest: [function (data, headers) {
                return JSON.stringify(params)
              }],
              headers: {'Content-Type': 'application/json;charset=utf-8'},
            }).then(function (res) {
              if (!res) {
                self.$Message.error('处理失败!')
              } else if (res.data > 0) {
                self.search()
                self.$Message.success('处理成功!')
                self.getWodetail(self.queryParam.uid)
              }
              self.woSubmitLoading = false
              self.$Modal.remove()
            })
          })
        }
      })
    },
    saveWoData () {
      let self = this
      self.woSubmitLoading = true
      self.$refs.woFormData.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.woSubmitLoading = false
          return
        }

        let data = this.woFormData.saleWo
        let params = {}
        params.studentId = data.studentId
        params.payAmount = data.payAmount
        params.adviserName = data.adviserName
        params.studyAdviserName = data.studyAdviserName
        params.teacherName = data.teacherName
        params.woStatus = data.woStatus
        params.remark = data.remark
        params.classOpeningTime = dateFormat(data.classOpeningTime, 'YYYY-MM-DD HH:mm:ss')
        if (self.woVersion && self.woVersion !== 'undefined') {
          params.version = self.woVersion
        }
        if (self.disableTimeList) {
          params.disableTimeList = self.disableTimeList
        }
        self.$http.post('/sale/wo/save', {}, {
          transformRequest: [function (data, headers) {
            return JSON.stringify(params)
          }],
          headers: {'Content-Type': 'application/json;charset=utf-8'},
        }).then(function (res) {
          if (!res) {
            self.$Message.error('操作失败!')
          } else if (res.data > 0) {
            self.search()
            self.$Message.success('保存成功!')
          }
          self.woSubmitLoading = false
        })
      })
    },
    rollbackWoData () {
      let self = this
      self.woSubmitLoading = true
      self.$Modal.confirm({
        title: '提示',
        content: '是否<b>撤回</b>工单？',
        width: 300,
        loading: true,
        onCancel: () => {
          self.woSubmitLoading = false
        },
        onOk: () => {
          self.$Modal.remove()
          self.$refs.woFormData.validate((valid) => {
            if (!valid) {
              self.$Message.warning('信息输入错误!')
              self.woSubmitLoading = false
              return
            }
            let data = this.woFormData.saleWo
            data.classOpeningTime = dateFormat(data.classOpeningTime, 'YYYY-MM-DD HH:mm:ss')
            self.$http.post('/sale/wo/rollback', data).then(res => {
              if (res) {
                self.search()
                self.$Message.success('撤回成功!')
                self.getWodetail(self.queryParam.uid)
              }
              self.$Modal.remove()
              self.woSubmitLoading = false
            })
          })
        }
      })
    },
    openRecordScreen (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认<b>开启</b>录屏？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          self.$http.post('/bookLesson/updateRecordScreen', {openedId: row.id, isRecordScreen: 1}).then(res => {
            if (res) {
              self.search()
              self.$Message.success('处理成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    closeModal (val) {
      this.editUser = false
      this.UserOneLeaveModal = val
    },
    searchWithPage () {
      this.reloadWithPage = new Date().getTime()
    },
    onReloadClassIn (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确定 手动生成ClassIn ID ？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/user/lesson/reloadClassIn', {openedId: row.id}).then(res => {
            if (res) {
              self.searchWithPage()
              self.$Message.success('生成成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    viewRecordScreen (row) {
      this.$http.get('/bookLesson/getRecordScreenUrl?openedId=' + row.id).then(function (res) {
        window.open(res.data)
      })
    },
    openNewLessonModal (k, v) {
    //  window.open('http://develop.bops.kouyujie.cn/#/lesson/timetableDetailList?tchId=' + k + '&tchName=' + v)
      if (this.$appConfig.active === 'prod') {
        window.open('https://bops.kouyujie.cn/#/lesson/timetableDetailList?tchId=' + k + '&tchName=' + v)
      } else {
        window.open('https://develop.bops.kouyujie.cn/#/lesson/timetableDetailList?tchId=' + k + '&tchName=' + v)
      }
    // window.open('http://localhost:8086/#/lesson/timetableDetailList?tchId=' + k + '&tchName=' + v)
    },
    startTimeDateChange (value) {
      this.lessonParams.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endTimeDateChange (value) {
      this.lessonParams.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    startCreateTimeChange (value) {
      this.lessonParams.startCreateTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endCreateTimeChange (value) {
      this.lessonParams.endCreateTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    onBookUserFeedBackClose () {
      this.showBookUserFeedbackModal = false
    },
    onBookTchScoreFeedBackClose () {
      this.showBookTchScoreFeedbackModal = false
    },
    onBookTchFeedBackClose () {
      this.showBookTchFeedbackModal = false
    },
    onClassMemberClose (val) {
      this.showClassMemberTimeModal = false
    },
    onPreview (row) {
      let self = this
      if (row.tchChannel === 1) {
        if (self.$appConfig.active === 'prod') {
          window.open('https://hellokid.speakstreet.cn/fundPackage/contract?fundPackageId=' + row.id + '&uid=' + row.uid)
        } else {
          window.open('https://test-student.kouyujie.cn/fundPackage/contract?fundPackageId=' + row.id + '&uid=' + row.uid)
        }
      } else if (row.tchChannel === 2) {
        if (self.$appConfig.active === 'prod') {
          window.open('https://h5.speakstreet.cn/contract/contract.html?fundPackageId=' + row.id)
        } else {
          window.open('https://test-h5.kouyujie.cn/contract/contract.html?fundPackageId=' + row.id)
        }
      }
    },
    goBack () {
      this.$router.push({path: this.backPath, query: {param: this.parm}})
    },
    onEvaluationSheetModalClose () {
      this.showEvaluationSheetModal = false
      this.reprotId = null
    },
    changeDate (value) {
      this.followFormData.nextDate = value
    },
    onSelectedProvince (data) {
      if (data.value) {
        this.formData.province = data.value
      }
    },
    onSelectedCity (data) {
      if (data.value) {
        this.formData.city = data.value
      }
    },
    onSelectedArea (data) {
      if (data.value) {
        this.formData.block = data.value
      }
    },
    cancelRecommend (id) {
      let self = this
      this.$http.post('/tchRecommend/cancelRecommend', {id: id}).then(function (res) {
        if (res.data > 0) {
          self.$Message.success('取消成功!')
          self.searTchRecommend()
        }
      })
    },
    onTabClick (name) {
    // 触发推荐老师展示
      if (name === 'three') {
        this.searTchRecommend()
      }
      if (name === 'six') {
      // 订单合同
        this.searFundPackageList()
      }
      if (name === 'seven') {
        this.searCourseTypeList()
      }
    // 用户权益
      if (name === 'nine') {
        this.searClassHourList()
      }
      this.currentTab = name
    },
    searCourseTypeList () {
      let self = this
      this.$http.get('/userList/courseTypeList?uid=' + this.uid).then(function (res) {
        if (res.data) {
          self.courseTypeData = res.data
        }
      })
      this.searchWithPage()
    },
    searClassHourList () {
      let self = this
      this.$http.get('/class-hour/list?queryAll=true&uid=' + this.uid).then(function (res) {
        if (res.data) {
          self.classHourListData = res.data
        }
      })
      this.searchWithPage()
    },
    searFundPackageList () {
      let self = this
      this.$http.get('/fundPackage/list?uid=' + this.uid + '&pageSize=' + 10).then(function (res) {
        if (res.data) {
          self.fundPackageData = res
        }
      })
    },
    searTchRecommend () {
      let self = this
      this.$http.get('/tchRecommend/list?uid=' + this.uid + '&pageSize=' + 10).then(function (res) {
        if (res.data) {
          self.recommendData = res
          self.loadMonthRankScoresFor((self.recommendData && self.recommendData.data) ? self.recommendData.data : self.recommendData, 'tchId')
        }
      })
    },
    closeRecommendEdit () {
      this.searTchRecommend()
      this.recommendEdit = false
    },
    openRecommendEdit () {
      this.recommendEdit = true
    },
    deleteContact (val) {
      let contact = this.formData.userContacts
      let newContact = []
      for (let i in contact) {
        if (i !== val + '') {
          newContact.push(contact[i])
        }
      }
      this.formData.userContacts = newContact
    },
    addContact () {
      if (this.formData.userContacts.length >= 3) {
        this.$Message.warning('已到添加号码上限!')
        return
      }
      let contact = {}
      this.formData.userContacts.push(contact)
    },
    openStudentPage () {
      let self = this
      this.$http.get('/adminUser/getAdminToken?type=student').then(res => {
        if (res.data) {
          if (self.$appConfig.active === 'prod') {
            window.open('https://hellokid.speakstreet.cn/adminUserLogin?uid=' + self.formData.uid + '&token=' + res.data)
          } else {
            window.open('https://test-student.kouyujie.cn/adminUserLogin?uid=' + self.formData.uid + '&token=' + res.data)
          }
        }
      })
      return
    },
    lookRerot (id) {
      if (id) {
        this.reprotId = id
        this.showEvaluationSheetModal = true
      // window.open('http://medias.kouyujie.cn/' + url)
      }
    },
    editReport (id, status) {
      let self = this
      if (id) {
        let path = '/stageReport/update?id=' + id + '&status=' + status
        self.$http.post(path, this.formData).then((res) => {
          if (res && res.data > 0) {
            self.$Message.success('操作成功!')
            self.reportList()
          }
        })
      }
    },
    reportList () {
      let self = this
      self.$http.get('/stageReport/list?uid=' + self.followFormData.id).then(function (res) {
        if (res.data) {
          self.stageReportData = res.data
          self.loadMonthRankScoresFor(self.stageReportData, 'tchId')
        }
      })
    },
    insertReport () {
      this.StageReportModal = true
    },
    play (url) {
      window.open(url)
    },
    search () {
      let self = this
      self.$http.get('/call_record/pageList?uid=' + self.queryParam.uid).then(function (res) {
        if (res.data.data) {
          self.callRecordData = res.data.data
        }
      })
    },
    onLoading (loading) {
      this.insertLoading = loading
    },
        onLessonLoading (loading) {
      this.searchLoading = loading
    
      if (!loading) {
        const bookList = this.$refs.bookLessonList && this.$refs.bookLessonList.tableData
        this.loadMonthRankScoresFor(bookList, 'tchId')
      }
    },

    changeFollow (val) {
      let self = this
      if (!val) {
        return
      }
      self.followFormData.traceItem = ''
      if (val === '100') {
        self.followList = [{id: 100, text: '注册备注'}]
        self.followFormData.traceItem = 100
      }
      if (val === '1') {
        self.followList = [{id: 1, text: '课后-同意购买'}, {id: 2, text: '课后-付款成功，持续跟进'}]
      }
      if (val === '2') {
        self.followList = [{id: 3, text: '课后-讲解产品，学习方案'}]
      }
      if (val === '3') {
        self.followList = [{id: 4, text: '课后-开场'}, {id: 5, text: '课前跟进，确认出席'}, {
          id: 6,
          text: '课前跟进，改期'
        }, {id: 7, text: '课前约课'}]
      }
      if (val === '4') {
        self.followList = [{id: 8, text: '价格问题'}, {id: 9, text: '行业对比'}, {id: 10, text: '不信任'}, {
          id: 11,
          text: '级别年龄不符'
        }]
      }
      if (val === '5') {
        self.followList = [{id: 12, text: '无人接听'}, {id: 13, text: '挂断'}, {id: 14, text: '关机/停机'}, {
          id: 15,
          text: '空号'
        }]
      }
    },
    addFollow () {
      let self = this
      self.$refs.followForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          return
        }
        if (self.followFormData.id) {
          if (self.followFormData.traceStatus == 100 || self.followFormData.traceStatus == '100') {
            self.$http.post('/userTrack/insert', {
              uid: self.followFormData.id,
              content: self.followFormData.content,
              files: self.followFormData.files || '',
              traceType: 100
            }).then(function (res) {
              if (res && res.data > 0) {
                self.$Message.success('保存成功!')
                self.followFormData.traceStatus = ''
                self.followFormData.traceItem = ''
                self.followFormData.content = ''
                self.followFormData.nextDate = ''
                self.followFormData.files = ''
                self.nextDate = ''
                self.askForTch = false
                self.$http.get('/saleTrace/followUp?id=' + self.followFormData.id).then(function (res) {
                  if (res && res.data) {
                    self.followData = res.data.list || []
                  }
                })
              }
            })
            return
          }
          let requireNum = []
          requireNum.push(...self.followFormData.stuDescCheckGroup)
          requireNum.push(...self.followFormData.askForTchCheckGroup)
          self.$http.post('/saleTrace/insert', {
            uid: self.followFormData.id,
            traceStatus: self.followFormData.traceStatus,
            traceItem: self.followFormData.traceItem,
            content: self.followFormData.content,
            nextDate: self.followFormData.nextDate,
            requireNum: requireNum.toString()
          }).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('保存成功!')
              self.followFormData.traceStatus = ''
              self.followFormData.traceItem = ''
              self.followFormData.content = ''
              self.followFormData.nextDate = ''
              self.nextDate = ''
              self.askForTch = false
              self.$http.get('/saleTrace/followUp?id=' + self.followFormData.id).then(function (res) {
                if (res && res.data) {
                  self.followData = res.data.list || []
                }
              })
            }
          })
        }
      })
    },
    resetRequireNum () {
      this.nextDate = ''
      this.followFormData.askForTchCheckGroup = []
      this.followFormData.stuDescCheckGroup = []
      this.askForTch = false
    },
    calcAgeFromBirthday () {
      if (!this.formData.birthday) return
      let now = new Date()
      let birthday = new Date(this.formData.birthday)
      let age = now.getFullYear() - birthday.getFullYear()
      let m = now.getMonth() - birthday.getMonth()
      if (m < 0 || (m === 0 && now.getDate() < birthday.getDate())) {
        age--
      }
      if (age >= 0) {
        this.formData.age = age
      }
    },
    calcBirthdayFromAge () {
      if (!this.formData.age || parseInt(this.formData.age) <= 0) return
      let now = new Date()
      let year = now.getFullYear() - parseInt(this.formData.age)
      let birthday = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      birthday.setFullYear(year)
      this.formData.birthday = birthday.getTime()
    },
    toSubmitFormData () {
      let data = JSON.parse(JSON.stringify(this.formData))
      if (data.birthday) {
        data.birthday = data.birthday / 1000
      }
      return data
    },
    addStudent () {
      let self = this
      self.insertLoading = true
      let res = self.valiDateParam()
      if (!res) {
        this.$Message.warning('参数输入错误!')
        if (self.paramsErrors.length > 0) {
          for (let i in self.paramsErrors) {
            this.$Message.warning(self.paramsErrors[i])
          }
          self.paramsErrors = []
        }
        self.insertLoading = false
        return
      }
      if (!self.formData.uid) {
        self.$http.get('/user/queryByMobile?mobile=' + self.formData.mobile).then(function (res) {
          if (res.data) {
            this.$Message.warning('学员手机号已经存在!')
          }
        })
        self.$http.post('/userinfo/insertUserInfo', JSON.stringify(self.toSubmitFormData())).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false
            self.$Message.success('新增成功!')
            self.successCallback()
          }
          self.insertLoading = false
        }).catch(function (e) {
          self.visible = false
          self.insertLoading = false
        })
      } else {
        if (self.formData.smsCode !== '' || self.formData.smsCode != null) self.formData.smsCode = ''
        if (!self.formData.oldMobile.startsWith('n') &&
        this.formData.oldMobile !== self.formData.mobile) {
          self.$Modal.confirm({
            title: '⚠警告',
            width: 300,
            loading: true,
            okText: '修改',
            render: (h, params) => {
              return h('div', [
                h('b', {style: {color: 'red'}}, '系统检测到您正常修改学生的手机号，这可能会影响用户上课，我们需要对修改后的手机号进行验证码验证，以确保是正式学员家长的诉求'),
                h('Input', {
                  attrs: {maxlength: 6},
                  on: {
                    input: (e) => {
                      self.formData.smsCode = e
                    }
                  }
                }),
                h('Button', {
                  attrs: {disabled: self.disabled},
                  on: {
                    click: () => {
                      self.$http.get('/userinfo/sendUpdateMobileSmsCode', {params: {uid: self.formData.uid}, key: 'update_mobile_sms'}).then(res => {
                        if (res.status === 'ok') {
                          self.$Message.success('验证码发送成功!')
                          self.disabled = true
                          self.timer = setInterval(() => {
                            if (self.time <= 0) {
                              self.time = 60
                              clearInterval(this.timer)
                              self.disabled = false
                            } else {
                              self.time -= 1
                            }
                          }, 1000)
                        }
                      })
                    }
                  }
                }, self.disabled ? self.time : '发送验证码')
              ])
            },
            onOk: () => {
              self.$Modal.remove()
              if (self.currentTab === 'one') {
                self.formData.classRequirement = ''
                if (self.followData) self.followData.classRequirementTags = []
              } else if (self.currentTab === 'classRequirement') {
                let uid = self.formData.uid
                let classRequirement = self.formData.classRequirement
                let classRequirementTags = self.formData.classRequirementTags
                self.formData = {}
                self.formData.uid = uid
                self.formData.classRequirement = classRequirement
                self.formData.classRequirementTags = classRequirementTags
              }
              self.$http.post('/userinfo/updateUserInfo', {}, {
                transformRequest: [function (data, headers) {
                  return JSON.stringify(self.toSubmitFormData())
                }],
                headers: {'Content-Type': 'application/json;charset=utf-8'},
              }).then(function (res) {
                self.insertLoading = false
                if (res) {
                  self.$Message.success('修改成功!')
                  self.visible = false
                  return
                }
              }).catch(function (e) {
                self.insertLoading = false
              })
            },
            onCancel: () => {
              self.time = 60
              clearInterval(this.timer)
              self.insertLoading = false
              self.disabled = false
              return false
            }
          })
        } else {
          if (self.formData.mobile === '') {
            self.formData.mobile = self.formData.oldMobile
          }
          let req = {}
          if (self.currentTab === 'classRequirement') {
            req.uid = self.formData.uid
            req.classRequirement = self.formData.classRequirement
            req.classRequirementTags = self.formData.classRequirementTags
          } else {
            self.formData.classRequirement = ''
            self.formData.classRequirementTags = []
            req = self.toSubmitFormData()
          }
          self.$http.post('/userinfo/updateUserInfo', {}, {
            transformRequest: [function (data, headers) {
              return JSON.stringify(req)
            }],
            headers: {'Content-Type': 'application/json;charset=utf-8'},
          }).then(function (res) {
            self.insertLoading = false
            if (res) {
              self.$Message.success('修改成功!')
              self.visible = false
              if (self.formData.mobile.startsWith('n')) {
                self.formData.mobile = ''
              }
              return
            }
          }).catch(function (e) {
            self.insertLoading = false
          })
        }
      }
    },
    valiDateParam () {
      let self = this
      let isPass = false
      self.$refs.userInfoForm.validate((valid) => {
        let res = self.valiDateMobile()
        if (valid && res) {
          isPass = true
        }
      })
      return isPass
    },
    closeReviewModal (val) {
      this.studentWriteReviewRegularModal = false
      this.studentWriteReviewDemoModal = false
      this.studentWriteReviewDemoV2Modal = false
      this.studentWriteReviewFinishLevelModal = false
      this.studentWriteReviewFinishLevelV2Modal = false
      this.studentWriteReviewRegularV2Modal = false
    },
    valiDateMobile () {
      let isPass = false
      let self = this
      let pattern = /^[0-9]+$/
      if (self.formData.userContacts && self.formData.userContacts.length > 0) {
        for (let i in self.formData.userContacts) {
          let param = self.formData.userContacts[i]
          if (!param.name) {
            self.paramsErrors.push('联系人名字不能为空!')
          } else if (!param.mobile) {
            self.paramsErrors.push('联系人号码不能为空!')
          } else if (!pattern.test(param.mobile)) {
            self.paramsErrors.push('手机号只能输入数字!')
          } else {
            isPass = true
          }
        }
      }
      if (self.paramsErrors && self.paramsErrors.length > 0) {
        isPass = false
      } else {
        isPass = true
      }
      return isPass
    },
    dialTel () {
    // 呼出电话功能
//      if (!this.formData.exten) {
//        this.$Message.warning('无效的话机工号')
//        return
//      }
//      this.dialLoading = true
//      this.$http.get('https://192.168.0.10:8443/api/call?team=hk&studentId=' + this.formData.uid + '&exten=' + this.formData.exten).then(function (res) {
    // if (res.code === 200) {
    //   this.$Message.success('呼叫成功!')
    //   this.dialLoading = false
    // } else {
    //   this.$Message.warning('呼叫失败!')
    // }
//      })
      if (!this.formData.mobile) {
        this.$Message.warning('无效手机号码')
        return
      }
      this.dialLoading = true
      let self = this
      this.$http.get('/moor/call?callNo=' + this.formData.mobile).then(function (res) {
        if (res.data > 0) {
          self.$Message.success('呼出成功!')
          self.dialLoading = false
        }
      })
    },
    handleResult (file) {
      this.formData.imageUrl = file.name
      this.totalImageUrl = file.url
    },
    openTrackContent (item) {
      this.$refs.trackContentModal && this.$refs.trackContentModal.open(item)
    },
    handleAiMarkdown () {
      let self = this
      let content = (self.formValidate.content || '').trim()
      if (!content) {
        self.$Message.warning('请先填写内容')
        return
      }
      self.aiLoading = true
      self.$http.post('/userTrack/aiMarkdown', {content: content}).then(function (res) {
        self.aiLoading = false
        if (!res || res.status !== 'ok' || !res.data || !res.data.markdown) {
          return
        }
        let markdown = res.data.markdown
        self.$Modal.confirm({
          title: '确认覆盖',
          content: '将用 AI 结果覆盖当前内容，是否继续？',
          onOk: function () {
            if (!(self.formValidate.contentRaw || '').trim()) {
              self.formValidate.contentRaw = content
            }
            self.formValidate.content = markdown
            self.$Message.success('已用 AI 结果更新内容')
          }
        })
      }).catch(function () {
        self.aiLoading = false
      })
    },
    handleSubmit () {
      let self = this
      this.$refs.form.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          return
        }
        if (self.formValidate.nextHandlerTime || self.formValidate.nextHandlerId) {
          if (!self.formValidate.nextHandlerTime || !self.formValidate.nextHandlerId) {
            self.$Message.warning('请填写下次联系人和下次联系日期!')
            return
          }
        }
        self.$http.post('/userTrack/insert', self.formValidate).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('提交成功!')
            self.formValidate.content = ''
            self.formValidate.contentRaw = ''
            self.formValidate.nextHandlerId = null
            self.formValidate.nextHandlerTime = ''
            self.formValidate.traceType = ''
            self.formValidate.nextTimeDate = ''
            self.getPersonTrace(self.formValidate.uid)
          }
        })
      })
    },
    nextTimeDateChange (value) {
      this.formValidate.nextHandlerTime = value
    },
    getPersonTrace (uid) {
      let self = this
      let params = self.traceParam
      if (uid) {
        self.$http.get('/userTrack/getPersonTrace?uid=' + uid + '&pageIndex=' + params.pageIndex + '&pageSize=' + params.pageSize).then(function (res) {
          if (!res.data || !res.data.data) {
            self.traceParam.totalCount = 0
            self.tableData = []
            return
          }
          self.traceParam.uid = res.data.data[0].uid
          self.traceParam.nickName = res.data.data[0].nickname
          self.traceParam.totalCount = res.data.totalCount
          self.tableData = res.data.data
        })
      }
    },
    changePageIndex (page) {
      this.traceParam.pageIndex = page
      this.getPersonTrace(this.traceParam.uid)
    },
    splitFixedRequire (text) {
      if (!text) {
        return []
      }
      return text.split(/\r?\n/).map(function (line) {
        return line.trim()
      }).filter(function (line) {
        return line.length > 0
      })
    },
    loadFixedClassRequire () {
      let self = this
      let uid = self.uid || self.formData.uid
      if (!uid) {
        return
      }
      self.$http.get('/stageReport/fixed-class-require?uid=' + uid).then(function (res) {
        if (res && res.status === 'ok') {
          let data = res.data || {}
          self.fixedClassRequire = data.fixedContent || ''
          self.fixedClassRequireEn = data.fixedContentEn || ''
        }
      }).catch(function () {
        // 失败不挡住整页，错误由拦截器提示
      })
    },
    saveFixedClassRequire () {
      let self = this
      let uid = self.uid || self.formData.uid
      if (!uid) {
        return
      }
      self.fixedClassRequireSaving = true
      self.$http.post('/stageReport/fixed-class-require-save', {
        uid: uid,
        fixedContent: self.fixedClassRequire
      }).then(function (res) {
        self.fixedClassRequireSaving = false
        if (res && res.status === 'ok') {
          let data = res.data || {}
          self.fixedClassRequire = data.fixedContent || ''
          self.fixedClassRequireEn = data.fixedContentEn || ''
          self.$Message.success('保存成功')
        }
      }).catch(function () {
        self.fixedClassRequireSaving = false
      })
    },
    init () {
      let self = this
      let query = self.$route.query
      if (query) {
        if (query.startTimeDate) {
          self.lessonParams.startTimeDate = parseInt(query.startTime) * 1000
        }
        if (query.endTimeDate) {
          self.lessonParams.endTimeDate = parseInt(query.endTime) * 1000
        }
        if (query.startCreateDate) {
          self.lessonParams.startCreateDate = parseInt(query.startCreateTime) * 1000
        }
        if (query.endCreateDate) {
          self.lessonParams.endCreateDate = parseInt(query.endCreateTime) * 1000
        }
        if (query.tchId) {
          self.lessonParams.tchId = parseInt(query.tchId)
        }
        if (query.tchName) {
          self.lessonParams.tchName = query.tchName
        }
        if (query.materialVersionId) {
          self.lessonParams.materialVersionId = parseInt(query.materialVersionId)
        }
        if (query.isStudyAdviser) {
          self.lessonParams.isStudyAdviser = query.isStudyAdviser
        }
        if (query.userNickname) {
          self.lessonParams.userNickname = query.userNickname
        }
        if (query.adviserNickname) {
          self.lessonParams.adviserNickname = query.adviserNickname
        }
        if (query.studyAdviserNickname) {
          self.lessonParams.studyAdviserNickname = query.studyAdviserNickname
        }
        if (query.tchCategory) {
          self.lessonParams.tchCategory = parseInt(query.tchCategory)
        }
        if (query.lsnSelStatus) {
          self.lessonParams.lsnSelStatus = parseInt(query.lsnSelStatus)
        }
        if (query.lsnType) {
          self.lessonParams.lsnType = parseInt(query.lsnType)
        }
        if (query.courseType) {
          self.lessonParams.courseType = parseInt(query.courseType)
        }
        if (query.adviserId) {
          self.lessonParams.adviserId = parseInt(query.adviserId)
        }
        if (query.creatorName) {
          self.lessonParams.creatorName = query.creatorName
        }
      }
    },

    cancelAllClass () {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确定 取消全部排课？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.get('/bookLesson/cancelAllClass?uid=' + self.queryParam.uid).then(function (res) {
            if (res && res.status === 'ok') {
              self.$Message.success('取消成功!')
              self.searchWithPage()
            }
            self.$Modal.remove()
          })
        }
      })
    },

    onChangeDisableStartTime (val) {
      this.disableTimeParams.disableStartTimeStr = val
      this.disableTimeParams.disableStartTime = this.$dateUtil.getSecondByHm(val)
    },
    onChangeDisableEndTime (val) {
      this.disableTimeParams.disableEndTimeStr = val
      this.disableTimeParams.disableEndTime = this.$dateUtil.getSecondByHm(val)
    },
    addDisableTime () {
      let self = this
      let isPass = true

      let disableTimeList = self.disableTimeList
      let week = self.disableTimeParams.disableWeek
      let startTime = self.disableTimeParams.disableStartTime
      let endTime = self.disableTimeParams.disableEndTime

      if (!week || week === '') {
        self.$Message.error('不可用星期选项不能为空')
        isPass = false
      }

      if (isPass) {
        if (!startTime) {
          self.disableTimeParams.disableStartTimeStr = '00:00'
          startTime = this.$dateUtil.getSecondByHm('00:00')
          self.disableTimeParams.disableStartTime = startTime
        }
        if (!endTime) {
          self.disableTimeParams.disableEndTimeStr = '23:59'
          endTime = this.$dateUtil.getSecondByHm('23:59')
          self.disableTimeParams.disableEndTime = endTime
        }
      }

      if (isPass && startTime && endTime) {
        if (startTime > endTime) {
          self.$Message.error('开始时间 ' + self.disableTimeParams.disableStartTimeStr +
          '必须小于' + self.disableTimeParams.disableEndTimeStr)
          isPass = false
        } else if (startTime === endTime) {
          self.$Message.error('开始时间 ' + self.disableTimeParams.disableStartTimeStr +
          '不能与结束时间' + self.disableTimeParams.disableEndTimeStr + '相等')
          isPass = false
        }
      }

      if (isPass && disableTimeList && disableTimeList.length > 0) {
        disableTimeList.forEach(function (item) {
          let tmpWeek = item.disableWeek
          let tmpStartTime = item.disableStartTime
          let tmpEndTime = item.disableEndTime
          if (week === tmpWeek) {
            if (((tmpStartTime < startTime && tmpEndTime > startTime) ||
            (tmpStartTime < endTime && tmpEndTime > endTime) ||
            (tmpStartTime >= startTime && tmpEndTime <= endTime))) {
              self.$Message.error('添加的时间与 ' + item.disableWeekStr + ' ' +
              item.disableStartTimeStr + '--' + item.disableEndTimeStr + ' 冲突')
              isPass = false
            }
          }
        })
      }

      if (isPass) {
        let disableTime = {}
        disableTime.disableWeek = self.disableTimeParams.disableWeek
        disableTime.disableWeekStr = self.$constant.weekZh[self.disableTimeParams.disableWeek]
        disableTime.disableStartTime = self.disableTimeParams.disableStartTime
        disableTime.disableStartTimeStr = self.disableTimeParams.disableStartTimeStr
        disableTime.disableEndTime = self.disableTimeParams.disableEndTime
        disableTime.disableEndTimeStr = self.disableTimeParams.disableEndTimeStr
        self.disableTimeList.push(disableTime)
      }
    },
    removeDisableTime (index) {
      this.disableTimeList.splice(index, 1)
    },
    clickWoVersion (val) {
      if (val) {
        this.woVersion = '1'
      } else {
        this.woVersion = '0'
        this.disableTimeList = []
      }
    },
    viewPic (row) {
      this.showImgList = row.nickname ? row.nickname.split(',').map(item => {
        if (!item.startsWith('http')) {
          return 'https://imgs.speakstreet.cn/' + item
        }
        return item
      }) : []
      this.showImgModal = true
    },
    closeImgModal () {
      this.showImgList = []
      this.showImgModal = false
    },
    // 定义各类别的需求标签
    generalRequirements: [
      '活跃一些',
      '多微笑，不要太严肃',
      '纠音',
      '纠正错误表达',
      '引导多开口',
      '多些互动',
      '引导整句输出',
      '多鼓励孩子',
      '多给些奖励'
    ],
    lowLevelRequirements: [
      '语速慢一点',
      '多些TPR',
      '多些道具',
      '课前互动简单一些最多3个问题',
      '学生零基础，不要拓展',
      '减少拓展'
    ],
    highLevelRequirements: [
      '内容拓展'
    ],
  },
  watch: {
    cityInfo (val) {
      if (val) {
        this.formData.province = val.province.name
        this.formData.city = val.city.name
        this.formData.block = val.block.name
      }
    }
  },


  created: function () {
    let uid = parseInt(this.$route.query.uid)
    // 支持字符串和数字类型的tabName
    const validTabs = ['one', 'two', 'tree', 'four', 'five', 'six', 'seven', 'eight', 'nine']
    let tabName = this.$route.query.tabName
    if (tabName !== undefined && tabName !== null && tabName !== '') {
      if (typeof tabName === 'string') {
        this.tabName = tabName
      } else {
        this.tabName = String(tabName)
      }
      if (!validTabs.includes(this.tabName)) {
        this.tabName = 'one'
      }
    }
    this.currentTab = this.tabName
    this.parm = this.$route.query.parm
    this.backPath = this.$route.query.backPath
    let self = this
    if (uid) {
      this.uid = uid
      self.formData.uid = uid
      self.loadFixedClassRequire()
      self.getWodetail(uid)
      self.$http.get('/saleTrace/followUp?id=' + uid).then(function (res) {
        if (res.data) {
          self.followFormData.id = res.data.id
          self.followFormData.adviserName = res.data.adviserName
          self.followFormData.nickname = res.data.nickname
          self.followFormData.studyAdviserName = res.data.studyAdviserName
          let requireNum = res.data.requireNum
          if (requireNum) {
            let require = requireNum.split(',')
            for (let i in require) {
              let j = parseInt(require[i])
              let len = self.$constant.stuDesc.length + 1
              if (j < len) {
                self.followFormData.stuDescCheckGroup.push(j)
              } else {
                self.followFormData.askForTchCheckGroup.push(j)
              }
            }
          }
          self.formValidate.uid = uid
          self.formValidate.nickname = res.data.nickname
          self.formValidate.adviserName = res.data.adviserName
          self.formValidate.studyAdviserName = res.data.studyAdviserName
          self.followFormData.tchNames = res.data.tchNames
          self.followData = res.data.list || []
        }
      })
      this.$http.post('/adminUser/listByCondition', {status: 1}).then(function (res) {
        self.nextHandler = res.data
      })
      self.getPersonTrace(uid)
      self.$http.get('/stageReport/list?uid=' + uid).then(function (res) {
        if (res.data) {
          self.stageReportData = res.data
        }
      })
      self.$http.get('/userinfo/appVersion/list?uid=' + uid).then(function (res) {
        self.appVersionData = res.data || {}
      })
      self.$http.get('/mex/blueprints/list', {
        params: {examType: 'SUMMATIVE', status: 'ONLINE', pageIndex: 1, pageSize: 200}
      }).then(function (res) {
        let rows = []
        if (res.status === 'ok' && res.data && res.data.data) {
          rows = res.data.data
        }
        self.summativeBlueprints = rows
      })
      
      self.harvardForeignLoaded = false
      self.$http.get('/user/harvardForeignAuth/get', {params: {uid: uid}}).then(function (res) {
        if (res && res.data) {
          self.harvardForeignEnabled = res.data.enabled === 1
        } else {
          self.harvardForeignEnabled = false
        }
        self.harvardForeignLoaded = true
      }).catch(function () {
        self.harvardForeignEnabled = false
        self.harvardForeignLoaded = true
      })

      self.$http.get('/mex/student-summative/get', {params: {uid: uid}}).then(function (res) {
        if (res.status === 'ok' && res.data) {
          self.summativeEnabled = res.data.enabled === 1
          self.summativeBlueprintId = res.data.blueprintId || null
        }
        self.$nextTick(function () {
          self.summativeLoaded = true
        })
      }).catch(function () {
        self.summativeLoaded = true
      })
      self.$http.get('/userinfo/getUserInfo?uid=' + uid).then(function (res) {
        if (res.data) {
          self.formData.oldMobile = res.data.mobile
          let data = res.data
          self.formData.channelParam = data.channelParam
          self.formData.enName = data.enName
          self.formData.enabledRule = data.enabledRule
          self.formData.stars = data.stars
          self.formData.tchIdCopy = data.tchIdCopy
          self.formData.cnName = data.cnName
          self.formData.vipDesc = data.vipDesc
          self.formData.sex = data.sex
          self.formData.regType = data.regType
          self.formData.payCanal = data.payCanal
          if (data.mobile.startsWith('n')) {
            self.formData.mobile = ''
          } else {
            self.formData.mobile = data.mobile
          }
          self.formData.remarkMobile = data.remarkMobile
          self.formData.phoneName = data.phoneName
          self.formData.wechatAccount = data.wechatAccount
          self.formData.phoneRole = data.phoneRole
          self.formData.infoRemark = data.infoRemark
          self.formData.address = data.address
          self.formData.learnEnglishTime = data.learnEnglishTime
          self.formData.haveContactForeignTeacher = data.haveContactForeignTeacher
          self.formData.familyEconomicSituation = data.familyEconomicSituation
          self.formData.attentionEnglish = data.attentionEnglish
          self.formData.province = data.province
          self.formData.city = data.city
          self.formData.block = data.block
          self.formData.imageUrl = data.imageUrl
          self.formData.age = data.age
          self.formData.intentLevel = data.intentLevel
          self.formData.noStudyAdviserRemind = data.noStudyAdviserRemind === 1 ? 1 : 0
          self.formData.connectionStatus = data.connectionStatus
          self.formData.userContacts = data.userContacts
          self.formData.grade = data.grade
          self.formData.exten = data.exten
          self.formData.birthday = data.birthday * 1000
          self.formData.tchChannel = data.tchChannel
          if (data.imageUrl) {
            if (data.imageUrl.indexOf('http://') !== -1) {
              self.totalImageUrl = data.imageUrl
            } else {
              if (data.imageUrl.substr(0, 4) === 'http') {
                self.totalImageUrl = data.imageUrl
              } else {
                self.totalImageUrl = 'http://medias.kouyujie.cn/' + data.imageUrl
              }
            }
            self.text = '编辑头像'
          } else {
            self.totalImageUrl = 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg'
            self.text = '上传头像'
          }

          self.userModal = data.userModal
          self.formData.allowCallReminder = data.allowCallReminder
          self.formData.allowSmsReminder = data.allowSmsReminder
          self.formData.mobileRemind = data.mobileRemind == null ? 1 : data.mobileRemind
          self.formData.remarkMobileRemind = data.remarkMobileRemind == null ? 1 : data.remarkMobileRemind
          self.formData.beforeClassCall = data.beforeClassCall == null ? 0 : data.beforeClassCall
          self.formData.remindHours = data.remindHours || ''
          self.formData.classRequirement = data.classRequirement
          self.formData.classRequirementTags = data.classRequirementTags
        }
        self.userInfoChecked = true
      }).catch(function () {
        self.userInfoChecked = true
      })
      self.queryParam.uid = uid
      self.queryParam.mobile = self.formData.oldMobile
      self.search()
    } else {
      self.formData.password = ''
    }
  },
  mounted: function () {
    this.init()
  }
}
</script>

<style scoped>/* 添加一些移动端优化样式 */
.fixed-class-require {
  margin: 8px 10px 16px;
}
.fixed-class-require-title {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
}
.fixed-class-require-en {
  margin: 8px 0 4px;
  color: #515a6e;
  line-height: 1.5;
}
.fixed-class-require-tags {
  margin-bottom: 8px;
}
.fixed-class-require-empty {
  margin-bottom: 8px;
  color: #999;
}
.fixed-class-require-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #999;
}
@media (max-width: 768px) {
  .ivu-form-item-label {
    text-align: left !important;
    padding-bottom: 5px !important;
  }

  .ivu-col {
    margin-bottom: 10px;
  }

  .telephone .ivu-btn-circle {
    width: 50px;
    height: 50px;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// UserPayDetail.vue?563768b1